import React, { useEffect, useState, useRef, useCallback } from "react";
import axios from "axios";
import { useMemo } from "react";
import Cookies from "js-cookie";
import notify from "../../../../../components/ACS-Dashboard/ACS-Blocks/Toast";
import "react-toastify/dist/ReactToastify.css";
import RenderShipmentModals from "./modals/RenderShipmentModals";
import {
  toAllowedActionsSet,
  hasAllowedAction,
} from "./shipmentActionPermissions";
import StickyHeader from "../../../../../components/ModuleCommon/StickyHeader/StickyHeader";
import {
  removeTab,
  setActiveTab,
} from "../../../../../redux/slices/shipmentSlice";
import ShipmentDocuments from "./ShipmentDocuments";
import ShipmentItems from "./ShipmentItems";
import ShipmentActivity from "./ShipmentActivity";
import {
  addTab as addInvoiceTab,
  setActiveTab as setActiveInvoiceTab,
} from "../../../../../redux/slices/invoiceSlice";

import { addTab as addLocationTab, setActiveTab as setLocationActiveTab } from "../../../../../redux/slices/locationSlice";
// import { addTab } from "../../../../../redux/slices/shipmentSlice";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  Undo2,
  Shuffle,
  Plus,
  XCircle,
  Minus,
  Unlink,
  Calendar,
  Edit,
  FileText,
  MapPin,
  Paperclip,
  DollarSign,
  Package,
  Users,
  ClipboardList,
  Image,
  Truck as TruckIcon,
  RefreshCcw,
  Trash,
  Loader2,
  Activity,
  AlertTriangle,
} from "lucide-react";
import { addTab as addAppointmentTab } from "../../../../../redux/slices/appointmentsSlices";
import { ShipmentDisplayDetail as DisplayDetail, formatShipmentInfoDataForDisplay } from "../shipmentShared";
import { ExpandableHeader } from "../../../../../components/ACS-Dashboard/ACS-Blocks/ExpandableHeader";
import FieldDropdown from "../../../../../components/ModuleCommon/FormBuilder/FieldDropdown";
import { toast } from "react-toastify";
import ProNumberModal from "./modals/ProNumberModal";
import { selectModuleTabs } from "../../../../../redux/selectors/tabsSelectors";
import { refreshRatesAndUpdateCharges } from "./rateRefresh";
import ScrollbarWrapper from "../../../../../components/ACS-Dashboard/ACS-Blocks/ScrollbarWrapper";
import { estimatedChargesApi } from "../Utils/estimatedChargesApi";
import { linkifyEmails } from "../../../../../components/ACS-Dashboard/ACS-Utils/textFormatting";
import {
  isRefreshBlockedForShipment,
  REFRESH_RATES_BLOCKED_MESSAGE,
  REFRESH_MILES_BLOCKED_MESSAGE,
} from "../shipmentShared";

const fallbackName = (companyName) => {
  if (typeof companyName !== "string") return companyName || "";
  const trimmed = companyName.trim();
  if (trimmed.startsWith("Diamond")) return "Diamond Pet Food";
  return trimmed;
};

const APPOINTMENT_MODES = {
  add:      { label: "New",  contentType: "newAppointment"  },
  update:   { label: "Edit", contentType: "editAppointment" },
  readonly: { label: "View", contentType: "viewAppointment" },
};

const ShipmentDetailsView = ({ shipmentNumber, shipmentOfficeCode }) => {
  const [shipmentDetails, setShipmentDetails] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showDocUploadModal, setShowDocUploadModal] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [isEditable, setIsEditable] = useState(false);
  const [isRefreshingMiles, setIsRefreshingMiles] = useState(false);
  const [showRefreshMilesWarning, setShowRefreshMilesWarning] = useState(false);
  const [showRefreshRatesWarning, setShowRefreshRatesWarning] = useState(false);
  const [isTemplateSaved, setIsTemplateSaved] = useState(false);
  const [activeSection, setActiveSection] = useState(null);
  const [isButtonActiveCarrier, setButtonActiveCarrier] = useState(false);
  const [isButtonTenderActiveShipper, setButtonTenderActiveShipper] =
    useState(false);
  const [isButtonRecallActiveShipper, setButtonRecallActiveShipper] =
    useState(false);
  const [isCarrier, setIsCarrier] = useState(false);
  const [isShipper, setIsShipper] = useState(false);
  const [isReceiver, setIsReceiver] = useState(false);
  const [status, setStatus] = useState(null);
  // was: const [showActualsModal, setShowActualsModal] = useState(false);
  const [showActualsModal, setShowActualsModal] = useState({
    open: false,
    mode: null,
  });
  const [showStopReasonModal, setShowStopReasonModal] = useState(false);
  const [showStatusBlink, setShowStatusBlink] = useState(false);
  const [uploadedDocs, setUploadedDocs] = useState([]);
  const [file, setFile] = useState(null);
  const [fileType, setFileType] = useState("");
  const [isUploading, setIsUploading] = useState(false);
  const [appointmentData, setAppointmentData] = useState(null);
  const [stopReasonCode, setStopReasonCode] = useState(null);
  const [stopReasonOptions, setStopReasonOptions] = useState([]);
  const [openStopReasonDropdown, setOpenStopReasonDropdown] = useState(null);
  const [isShipperOrg, setIsShipperOrg] = useState(false);
  const [isCarrierOrg, setIsCarrierOrg] = useState(false);
  const [expandedStops, setExpandedStops] = useState({});
  const [showRecallModal, setShowRecallModal] = useState(false);
  const [showReorderModal, setShowReorderModal] = useState(false);
  const [showAddStopModal, setShowAddStopModal] = useState(false);
  const [showCancelShipmentModal, setShowCancelShipmentModal] = useState(false);
  const [showRemoveOrdersModal, setShowRemoveOrdersModal] = useState(false);
  const isCompleted = status === "Completed";

  const [isEditMode, setIsEditMode] = useState(false);
  const [editedStops, setEditedStops] = useState({});
  const [isSavingStopChanges, setIsSavingStopChanges] = useState(false);
  const [editedCharges, setEditedCharges] = useState({});
  const [isSavingChargeChanges, setIsSavingChargeChanges] = useState(false);
  const [isRefreshingRates, setIsRefreshingRates] = useState(false);
  const [openChargeDropdown, setOpenChargeDropdown] = useState(null);
  const datePickersRef = useRef({});
  const permissionsFetchedRef = useRef(false);
  const { defaultTabs, dynamicTabs } = useSelector((s) => s.invoices);
  

  // Pro Number Modal at the time of Carrier Accept LGX-559
  const [showProModal, setShowProModal] = useState(false);
  const [proModalMode, setProModalMode] = useState("accept");

  //ReceiverCarrierSelectionModal
  const [showReceiverCarrierModal, setShowReceiverCarrierModal] =
    useState(false);
  const [receiverCarriers, setReceiverCarriers] = useState([]);
  const [initialReceiverCarrier, setInitialReceiverCarrier] = useState(null);
  const [activityLogs, setActivityLogs] = useState([]);
  const [isActivityLoading, setIsActivityLoading] = useState(false);
  const [showActivityPanel, setShowActivityPanel] = useState(false);
  const [orderNumber, setOrderNumber] = useState("");
  const [chargeCodes, setChargeCodes] = useState([]);
  const [codeMappings, setCodeMappings] = useState([]);
  const [editingAmountIdx, setEditingAmountIdx] = useState(null);
  const [comments, setComments] = useState("");
  const [isSavingComments, setIsSavingComments] = useState(false);

  const firstStop = useMemo(() => {
    const stops = shipmentDetails?.shipmentStops;
    if (!Array.isArray(stops) || stops.length === 0) return null;

    return [...stops].sort((a, b) => {
      const aSeq = a?.stopSequence ?? a?.stopNumber ?? Number.MAX_SAFE_INTEGER;
      const bSeq = b?.stopSequence ?? b?.stopNumber ?? Number.MAX_SAFE_INTEGER;
      return aSeq - bSeq;
    })[0];
  }, [shipmentDetails?.shipmentStops]);

  const canEditProNumber = useMemo(
    () => Boolean(firstStop && !firstStop.actualGateIn),
    [firstStop]
  );

  const manyOfficeCodes = Cookies.get("officeCodes");

  //Getting roles
 // Check privilege from localStorage
const userPrivileges = JSON.parse(localStorage.getItem("userPrivileges") || "[]");
const privilegeNames = userPrivileges.map(p => p.name);
const isAdminUser = privilegeNames.includes("shipments:ADMIN_VIEW"); // Only admins have this

  // 1) state to hold the API response
  const [permLoading, setPermLoading] = useState(false);
  const [permError, setPermError] = useState(null);
  // Bumped by the banner's Retry button. permissionsFetchedRef is only set on success,
  // so re-running the effect after a failure genuinely refetches.
  const [permRetryToken, setPermRetryToken] = useState(0);
  const permAbortRef = useRef(null);

  // replace: const [allowedActions, setAllowedActions] = useState([]);
  const [allowedActions, setAllowedActions] = useState(new Set());

  const hasPerm = useCallback(
    (name) => hasAllowedAction(allowedActions, name),
    [allowedActions]
  );

  // 2) tiny helper to infer role for the call
  // const inferRoleForShipment = (shipment, officeCode) => {
  //   const oc = (officeCode ?? "").trim();
  //   const eq = (a,b) => (a ?? "").trim() === (b ?? "").trim();
  //   if (eq(shipment?.shipperOfficeCode?.partyOfficeCode, oc))  return "shipper";
  //   if (eq(shipment?.carrierOfficeCode?.partyOfficeCode, oc))  return "carrier";
  //   if (eq(shipment?.receiverOfficeCode?.partyOfficeCode, oc)) return "receiver";
  //   return "other";
  // };

  const inferRoleForShipment = (shipment, manyOfficeCodes) => {
    const officeCodes = (manyOfficeCodes ?? "")
      .split(",")
      .map((code) => code.trim())
      .filter(Boolean); // removes empty strings

    const eqAny = (partyCode) =>
      officeCodes.some((code) => (partyCode ?? "").trim() === code);

    if (eqAny(shipment?.shipperOfficeCode?.partyOfficeCode)) return "shipper";
    if (eqAny(shipment?.carrierOfficeCode?.partyOfficeCode)) return "carrier";
    if (eqAny(shipment?.receiverOfficeCode?.partyOfficeCode)) return "receiver";
    return "other";
  };

  const handleAddCharge = () => {
    const newCharge = {
        code: "",
        chargeName: "",
        currency: "",
        amount: 0,
        chargeApprovalStatus: "PREAPPROVED",
        invoiceNumber: null,
    };

    setShipmentDetails((prev) => ({
        ...prev,
        charges: [...(prev.charges || []), newCharge],
    }));
}

const handleDeleteCharge = (chargeIndex) => {
    const currentCharge = shipmentDetails?.charges?.[chargeIndex];
    if (!currentCharge) return;

    // Mark charge as deleted in editedCharges
    setEditedCharges((prev) => ({
        ...prev,
        [chargeIndex]: {
            ...(prev[chargeIndex] || currentCharge),
            deleted: true,
            hasChanges: true,
        },
    }));
};

const handleChargeChange = (chargeIndex, field, value) => {
    const currentCharge = shipmentDetails?.charges?.[chargeIndex];
    if (!currentCharge) return;

    // Update editedCharges to track changes
    setEditedCharges((prev) => ({
        ...prev,
        [chargeIndex]: {
            ...(prev[chargeIndex] || currentCharge),
            [field]: value,
            hasChanges: true,
        },
    }));

    // Update shipment details optimistically
    setShipmentDetails((prev) => ({
        ...prev,
        charges: (prev.charges || []).map((charge, idx) =>
            idx === chargeIndex ? { ...charge, [field]: value } : charge
        ),
    }));
};

const handleChargeCodeChange = (chargeIndex, codeValue) => {
    const currentCharge = shipmentDetails?.charges?.[chargeIndex];
    if (!currentCharge) return;

    // Find the CodeMapping object for the selected code
    const selectedMapping = codeMappings.find((cm) => cm.code === codeValue);
    const description = selectedMapping?.description || "";

    // Update editedCharges to track changes
    setEditedCharges((prev) => ({
        ...prev,
        [chargeIndex]: {
            ...(prev[chargeIndex] || currentCharge),
            code: codeValue.trim(),
            chargeName: description,
            hasChanges: true,
        },
    }));

    // Update shipment details optimistically
    setShipmentDetails((prev) => ({
        ...prev,
        charges: (prev.charges || []).map((charge, idx) =>
            idx === chargeIndex
                ? { ...charge, code: codeValue.trim(), chargeName: description }
                : charge
        ),
    }));
};



// 3) fetch permissions once when shipment details are first loaded
  useEffect(() => {
    if (!shipmentDetails?.shipmentNumber) return;

    const manyOfficeCodes = Cookies.get("officeCodes");
    const authToken = Cookies.get("authToken");
    const role = inferRoleForShipment(shipmentDetails, manyOfficeCodes);
    const status = (shipmentDetails.status ?? "").toLowerCase(); // normalize if backend expects lowercase

    // Create a unique key for this shipment's permissions
    const permissionKey = `${shipmentDetails.shipmentNumber}-${status}-${role}`;
        
    // Check if we've already fetched permissions for this shipment/status/role combination
    if (permissionsFetchedRef.current === permissionKey) return;

    // cancel any in-flight request
    if (permAbortRef.current) permAbortRef.current.abort();
    permAbortRef.current = new AbortController();

    setPermLoading(true);
    setPermError(null);

    axios
      .get(
        `${process.env.REACT_APP_API_BASE_URL}/api/shipment/permissions/actions`,
        {
          params: {
            officeCode, // e.g. "CAD"
            objectType: "shipment",
            status, // e.g. "New" or "new" (match server expectation)
            role, // "shipper" | "carrier" | "receiver" | "other"
          },
          headers: {
            Authorization: `Bearer ${authToken}`,
            "Office-Code": officeCode,
          },
          signal: permAbortRef.current.signal,
        }
      )
      .then((res) => {
        setAllowedActions(toAllowedActionsSet(res.data));
        permissionsFetchedRef.current = permissionKey; // Mark as fetched for this combination
      })
      .catch((err) => {
        if (!axios.isCancel(err)) {
          console.error("[perm] fetch failed", err);
          setPermError(err?.response?.data ?? err?.message ?? "unknown error");
          setAllowedActions(new Set());
        }
      })
      .finally(() => setPermLoading(false));

    return () => permAbortRef.current?.abort();
    }, [shipmentDetails?.shipmentNumber, shipmentDetails?.status, permRetryToken]); // Only depend on stable identifiers

  // const formatDateOnly = (dateInput) => {
  //   if (!dateInput) return null;
  //   const date = new Date(dateInput);
  //   if (Number.isNaN(date.getTime())) return null;
  //   const month = String(date.getMonth() + 1).padStart(2, "0");
  //   const day = String(date.getDate()).padStart(2, "0");
  //   const year = date.getFullYear();
  //   return `${month}/${day}/${year}`;
  // };

  const formatDateOnly = (dateInput) => {
    if (!dateInput) return null;
    const date = new Date(dateInput);
    if (Number.isNaN(date.getTime())) return null;
    
    const month = String(date.getUTCMonth() + 1).padStart(2, "0");
    const day = String(date.getUTCDate()).padStart(2, "0");
    const year = date.getUTCFullYear();
    
    return `${month}/${day}/${year}`;
  };

  const handleUploadSuccess = (newDoc, fileType) => {
    console.log("Document name:", newDoc);
    console.log("File type:", fileType); // Log the received file type

    const newDocument = {
      name: newDoc,
      type: fileType, // Store the file type selected in the modal
      uploadDay: formatDateOnly(new Date()),
      uploadTime: new Date().toLocaleTimeString(),
      userUpload: "Current User",
    };

    setUploadedDocs((prevDocs) => {
      const updatedDocs = [...prevDocs, newDocument];
      console.log("Updated uploadedDocs:", updatedDocs); // Log the updated documents array
      return updatedDocs;
    });

    fetchActivityLogs();
  };

  const headerRef = useRef(null);
  const scrollContainerRef = useRef(null);
  const sectionRefs = useRef({});
  const abortControllerRef = useRef(new AbortController());
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const activeTabIndex = useSelector((state) => state.shipments.activeTab);
  const token = Cookies.get("authToken");
  const officeCode = shipmentOfficeCode;
  const [infoData, setInfoData] = useState({});
  const [formData, setFormData] = useState({});
  const [selectedFiles, setSelectedFiles] = useState([]);
  const isShipmentReady = useMemo(() => {
    return (
      shipmentDetails?.portOfOrigin &&
      shipmentDetails?.portOfDestination &&
      shipmentDetails?.pickupDate &&
      shipmentOfficeCode
    );
  }, [shipmentDetails]);

  const PACKAGE_TYPE_MAP = {
    BX: "Box",
    BG: "Bag",
  };

  const fileTypeMap = {
    PROOF_OF_DELIVERY: "Proof of Delivery",
    BILL_OF_LADING: "Bill of Lading",
    INVOICE: "Invoice",
    CUSTOMS: "Customs",
    // Add more mappings as needed
  };

  const formatDisplayDate = (dateString) => {
    if (!dateString) return null;
    const date = new Date(dateString);
    if (Number.isNaN(date.getTime())) return null;

    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const year = date.getFullYear();

    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const suffix = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12; // convert 0 to 12 for midnight
    const hourStr = String(hours).padStart(2, "0");

    return `${month}/${day}/${year} ${hourStr}:${minutes} ${suffix}`;
  };

  const formatTransitTime = (totalSeconds) => {
    if (!totalSeconds || totalSeconds <= 0) return null;

    const days = Math.floor(totalSeconds / 86400); // 1440 minutes = 24 hours
    let remainingSeconds = totalSeconds % 86400;
    const hours = Math.floor(remainingSeconds / 3600);
    remainingSeconds = remainingSeconds % 3600;
    const minutes = Math.floor(remainingSeconds / 60);
    remainingSeconds = remainingSeconds % 60;

    const parts = [];
    if (days > 0) parts.push(`${days}d`);
    if (hours > 0) parts.push(`${hours}h`);
    if (minutes > 0) parts.push(`${minutes}m`);
    if (remainingSeconds > 0) parts.push(`${remainingSeconds.toFixed(0)}s`);

    return parts.length > 0 ? parts.join(" ") : null;
  };

  // Updated handleScroll function
  const handleScroll = useCallback(() => {
    const container = scrollContainerRef.current;
    if (!container) return;

    const scrollTop = container.scrollTop + 100; // Add header offset buffer
    const containerHeight = container.clientHeight;

    let closestSection = null;
    let closestDistance = Infinity;
    let currentActive = null;

    // First pass: Check if scroll position is within any section's vertical range
    Object.entries(sectionRefs.current).forEach(([sectionName, element]) => {
      if (!element) return;

      const rect = element.getBoundingClientRect();
      const sectionTop = rect.top + scrollTop - container.offsetTop;
      const sectionBottom = sectionTop + rect.height;

      // Check if scroll position is within this section's view
      if (scrollTop >= sectionTop && scrollTop <= sectionBottom) {
        currentActive = sectionName;
      }
    });

    // Second pass: Find closest section if none in view
    if (!currentActive) {
      Object.entries(sectionRefs.current).forEach(([sectionName, element]) => {
        if (!element) return;

        const rect = element.getBoundingClientRect();
        const sectionTop = rect.top + scrollTop - container.offsetTop;
        const distance = Math.abs(scrollTop - sectionTop);

        if (distance < closestDistance) {
          closestDistance = distance;
          closestSection = sectionName;
        }
      });
      currentActive = closestSection;
    }

    if (currentActive && currentActive !== activeSection) {
      setActiveSection(currentActive);
    }
  }, [activeSection]);

  useEffect(() => {
    const container = scrollContainerRef.current;
    if (!container) return;

    const resizeObserver = new ResizeObserver(() => {
      // Recheck scroll position after layout changes
      handleScroll();
    });

    resizeObserver.observe(container);

    return () => resizeObserver.disconnect();
  }, [handleScroll]);

  useEffect(() => {
    const container = scrollContainerRef.current;
    if (!container) return;

    const mutationObserver = new MutationObserver(handleScroll);
    mutationObserver.observe(container, {
      childList: true,
      subtree: true,
      attributes: true,
      characterData: true,
    });

    return () => mutationObserver.disconnect();
  }, [handleScroll]);

  // Scroll listener setup
  useEffect(() => {
    const container = scrollContainerRef.current;
    if (!container) return;

    container.addEventListener("scroll", handleScroll);
    return () => container.removeEventListener("scroll", handleScroll);
  }, [handleScroll]);

  // Initial scroll position check
  useEffect(() => {
    handleScroll();
  }, [handleScroll, shipmentDetails]);

  // Fetch shipment details with cleanup
  const fetchShipmentDetails = useCallback(async () => {
    // if (abortControllerRef.current) abortControllerRef.current.abort();
    // abortControllerRef.current = new AbortController();
    abortControllerRef.current.abort();
    abortControllerRef.current = new AbortController();

    try {
      setIsLoading(true);
      setError(null);

      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/shipments/detailed-shipment/${shipmentNumber}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
            "Office-Code": officeCode,
          },
          signal: abortControllerRef.current.signal,
        }
      );

      console.log("the response for shipment details", response.data);

      const data = response.data;
      console.log("RAW charges from API:", JSON.stringify(data.charges, null, 2));

      if (status && status !== data.status) {
        setShowStatusBlink(true);
        setTimeout(() => setShowStatusBlink(false), 5000);
      }
      setShipmentDetails(data);
      setComments(data.comments || "");
      setStatus(data.status);
      // Seed the modal’s initially selected carrier from shipment details (if any)
      setInitialReceiverCarrier({
        code:
          data?.carrierOfficeCode?.partyOfficeCode || data?.carrierCode || "",
        name: data?.carrierOfficeCode?.name || data?.carrierName || "",
      });

      setUploadedDocs(
        (data.documents || []).map((doc) => ({
          name: doc.documentName,
          type: doc.documentType,
          id: doc.uuidFilename,
          // 👇 this is what ShipmentDocuments will read
          uploadedAt: doc.receiveQixieTime || doc.createdDate || null,
          userUpload: doc.user
            ? `${doc.user.firstName ?? ""} ${doc.user.lastName ?? ""}`.trim() || "System"
            : "System",
        }))
      );


      setFormData({
        shipmentNumber: data.shipmentNumber,
        officeCode: data.officeCode,
        paymentMethod: data.status || "",
        poNumber: data.poNumber || "",
        orderValue: data.orderValue || "",
        totalCharge: data.totalCharge || "",
      });

      setOrderNumber(data.salesOrderNumber || "");

      const role = inferRoleForShipment(
       shipmentDetails,
        manyOfficeCodes
      ).toLowerCase();

      if (role === "shipper") {
        setIsShipper(true);

        setButtonTenderActiveShipper(data.status === "Assigned");

        setButtonRecallActiveShipper(
          data.status !== "New" && data.status !== "Unassigned"
        );
      } else if (role === "carrier") {
        setIsCarrier(true);

        const isTendered = data.status === "Tendered";

        setButtonActiveCarrier(isTendered);
      } else if (role === "receiver") {
        setIsReceiver(true);
      }

      setInfoData({
        "Shipment Number": { type: "text", value: data.shipmentNumber || "" },
        "PO Number": { type: "text", value: data.poNumber || "" },
        "SO Number": { type: "text", value: data.salesOrderNumber || "" },
        "Total Charge": {
          type: "text",
          value: (!data.totalCharge || Number(data.totalCharge) === 0)
    ? ""
    : formatMoney(data.totalCharge, data.currency) ?? "",
        },

        // "Total Miles": {
        //   type: "text",
        //   value: data.totalMiles ? `${data.totalMiles} miles` : "",
        // },
        // "Total Transit Time": {
        //   type: "text",
        //   value: data.totalMinutes ? `${data.totalMinutes} min` : "",
        // },
        // "Equipment Type": { type: "text", value: "53 Feet Dry Van" || "" },
        "Requested Mode": { type: "text", value: data.movementType || "" },
        Status: { type: "text", value: data.status || "" },
        //  "Must Pickup By": { type: "text", value: data.shipmentStops[0].scheduledGateOut || "" },
        // "Must Deliver By": { type: "text", value: data.shipmentStops[data.shipmentStops.length-1].scheduledGateIn || "" },
      });

      console.log("ShipmentDetails", shipmentDetails);
    } catch (error) {
      if (!axios.isCancel(error)) {
        setError(error);
        console.error("Error fetching shipment details:", error);
      }
    } finally {
      setIsLoading(false);
    }
  }, [shipmentNumber, token, officeCode, status]);

  const handleSaveComments = async () => {
    setIsSavingComments(true);
    try {
        await axios.put(
            `${process.env.REACT_APP_API_BASE_URL}/api/shipments/${shipmentNumber}/comments`,
            { comments },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Office-Code": officeCode,
                },
            }
        );
        notify.success({ title: "Comments Saved", message: "Comments updated successfully." });
    } catch (err) {
        notify.error({ title: "Save Failed", message: "Could not save comments." });
    } finally {
        setIsSavingComments(false);
    }
};

  const fetchActivityLogs = useCallback(async () => {
    const oc = formData?.officeCode;
    if (!shipmentNumber || !oc) return;
    try {
      setIsActivityLoading(true);
      const response = await axios.get(
        `${
          process.env.REACT_APP_API_BASE_URL
        }/api/shipments/${encodeURIComponent(
          shipmentNumber
        )}/activity-logs/${encodeURIComponent(oc)}`,
        {
          headers: {
            Authorization: `Bearer ${Cookies.get("authToken")}`,
            "Office-Code": oc,
          },
        }
      );
      const sorted =
        Array.isArray(response.data)
          ? [...response.data].sort((a, b) => {
              const da = a?.updatedTime ? new Date(a.updatedTime).getTime() : 0;
              const db = b?.updatedTime ? new Date(b.updatedTime).getTime() : 0;
              return db - da; // newest first
            })
          : [];
      setActivityLogs(sorted);
    } catch (err) {
      console.error("Error fetching activity logs:", err);
      setActivityLogs([]);
    } finally {
      setIsActivityLoading(false);
    }
  }, [shipmentNumber, formData?.officeCode]);

  // Fetch Logs if office code is found on shipment response
  useEffect(() => {
    console.log("ActivityLog effect, officeCode:", formData?.officeCode);
    if (formData?.officeCode) fetchActivityLogs();
  }, [formData?.officeCode, fetchActivityLogs]);

  const openActivityPanel = () => {
    setShowActivityPanel(true);
    fetchActivityLogs();
  };

  useEffect(() => {
    try {
      const stored = localStorage.getItem("organizationTypes");
      if (!stored) {
        setIsShipperOrg(false);
        return;
      }
      const parsed = JSON.parse(stored);
      if (!Array.isArray(parsed)) {
        setIsShipperOrg(false);
        return;
      }
      const normalized = parsed
        .map((type) => (type ?? "").toString().toLowerCase().trim())
        .filter(Boolean);
      setIsShipperOrg(
        normalized.length === 1 && normalized[0] === "shipper"
      );
      setIsCarrierOrg(
        normalized.length === 1 && normalized[0] === "carrier"
      );
    } catch (err) {
      console.warn("Failed to read organizationTypes from storage:", err);
      setIsShipperOrg(false);
      setIsCarrierOrg(false);
    }
  }, []);

  useEffect(() => {
    const fetchStopReasons = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/api/code-mapping/type/stop_reason`
        );
        const normalize = (s) =>
          (s ?? "")
            .toString()
            .trim()
            .toUpperCase()
            .replace(/\s+/g, " ");
        const options = Array.isArray(res.data) ? res.data : [];
        const filtered = options.filter((opt) => {
          const code = normalize(opt.code);
          const desc = normalize(opt.description);
          const isDrop =
            code === "DT" ||
            desc === "DROP TRAILER" ||
            (desc.includes("DROP") && desc.includes("TRAILER"));
          const isLive =
            code === "LL" ||
            code === "LD" ||
            desc === "LIVE LOAD" ||
            desc === "LOAD";
          return isDrop || isLive;
        });
        setStopReasonOptions(
          filtered.length
            ? filtered
            : [
                { code: "LL", description: "Live Load" },
                { code: "DT", description: "Drop Trailer" },
              ]
        );
      } catch (err) {
        console.error("Failed to load stop reasons", err);
        setStopReasonOptions([
          { code: "LL", description: "Live Load" },
          { code: "DT", description: "Drop Trailer" },
        ]);
      }
    };

    fetchStopReasons();
  }, []);

    // Fetch charge codes from backend
    useEffect(() => {
    const fetchChargeCodes = async () => {
        try {
            const token = Cookies.get("authToken");
            const response = await axios.get(
                `${process.env.REACT_APP_API_BASE_URL}/api/code-mapping/type/accessorial`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Office-Code": officeCode,
                    },
                }
            );
            // Store full CodeMapping objects
            const mappings = Array.isArray(response.data) ? response.data : [];
            setCodeMappings(mappings);
            // Extract code values from CodeMapping objects for dropdown
            const codes = mappings.map((cm) => cm.code).filter(Boolean);
            setChargeCodes(codes);
        } catch (error) {
            console.error("Error fetching charge codes:", error);
            // Fallback to empty arrays on error
            setChargeCodes([]);
            setCodeMappings([]);
        }
    };
    fetchChargeCodes();
}, [officeCode]);

  useEffect(() => {
    if (!shipmentDetails) return;
    const pickupStop = shipmentDetails?.shipmentStops?.find(
      (stop) => stop.stopType === "PICKUP"
    );

    if (!pickupStop) return;
    setStopReasonCode(pickupStop.stopReasonCode);

    const fetchParentLocation = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/api/locations/parent/by-warehouse-details`,
          {
            params: {
              addressLine1: pickupStop.addressLine1 || "",
              addressLine2: pickupStop.addressLine2 || "",
              city: pickupStop.city || "",
              state: pickupStop.state || "",
              zipCode: pickupStop.zipCode || "",
              country: pickupStop.country || "",
              stopName: pickupStop.stopName || "",
              customLocationIdentifier:
                pickupStop.locationERPIdentifier || "",
            },
            headers: {
              Authorization: `Bearer ${token}`,
              "Office-Code": officeCode,
            },
          }
        );

        const parentLocation = response.data;
        console.log(
          "In shipment details view, the parent Location is ",
          response.data
        );

        setAppointmentData({
          shipmentNumber: shipmentDetails.shipmentNumber,
          company: shipmentDetails.shipperName,
          addressLine1: pickupStop.addressLine1,
          addressLine2: pickupStop.addressLine2,
          city: pickupStop.city,
          state: pickupStop.state,
          zipCode: pickupStop.zipCode,
          country: pickupStop.country,
          stopName: pickupStop.stopName,
          customLocationIdentifier: pickupStop.locationERPIdentifier,
          stopReasonCode: pickupStop.stopReasonCode,
          carrierName: shipmentDetails.carrierOfficeCode?.name || "",
          carrierOfficeCode:
            shipmentDetails.carrierOfficeCode?.partyOfficeCode || "",
          shipperName: shipmentDetails.shipperOfficeCode?.name || "",
          shipperOfficeCode:
            shipmentDetails.officeCode || "",
          location: parentLocation.locationRef,
          poNumber: shipmentDetails.poNumber || "",
          saleNumber: shipmentDetails.salesOrderNumber || "",
          mustPickUpBy: pickupStop.scheduledGateOut || "",
          mustDeliverBy: pickupStop.scheduledGateIn || "",
          proNumber: shipmentDetails.proNumber || "",
          shipmentStops: shipmentDetails.shipmentStops || [],
        });

        console.log(
          "🚚 Appointment Data:send to appointment",
          appointmentData
        );
      } catch (error) {
        console.error("Failed to fetch parent location:", error);
        setAppointmentData({
          shipmentNumber: shipmentDetails.shipmentNumber,
          company: shipmentDetails.shipperName,
          addressLine1: pickupStop.addressLine1,
          addressLine2: pickupStop.addressLine2,
          city: pickupStop.city,
          state: pickupStop.state,
          zipCode: pickupStop.zipCode,
          country: pickupStop.country,
          stopName: pickupStop.stopName,
          customLocationIdentifier: pickupStop.locationERPIdentifier,
          stopReasonCode: pickupStop.stopReasonCode,
          carrierName: shipmentDetails.carrierOfficeCode?.name || "",
          carrierOfficeCode:
            shipmentDetails.carrierOfficeCode?.partyOfficeCode || "",
          shipperName: shipmentDetails.shipperOfficeCode?.name || "",
          shipperOfficeCode:
            shipmentDetails.officeCode || "",
          location: shipmentDetails.shipperOfficeCode?.locationRef || "",
          poNumber: shipmentDetails.poNumber || "",
          saleNumber: shipmentDetails.salesOrderNumber || "",
          proNumber: shipmentDetails.proNumber || "",
        });
      }
    };

    fetchParentLocation();
  }, [shipmentDetails, officeCode, token]);

  const handleDelete = async (documentId) => {
    if (!documentId) {
      notify.error({ title: "Error", message: "Document ID is required." });
      return;
    }

    try {
      const token = Cookies.get("authToken");

      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/upload/shipmentDocuments/${shipmentNumber}/${documentId}/delete`,
        null, // No request body needed
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Office-Code": shipmentOfficeCode,
          },
        }
      );

      // Remove the document from the local state
      setUploadedDocs((prevDocs) =>
        prevDocs.filter((doc) => doc.id !== documentId)
      );

      // Refresh shipment details to get updated document list
      await fetchShipmentDetails();

      notify.success({
        title: "Document Deleted",
        message: "Document has been successfully deleted.",
      });
    } catch (error) {
      console.error("Delete failed:", error);
      notify.error({
        title: "Delete Failed",
        message:
          error.response?.data?.message ||
          "Failed to delete document. Please try again.",
      });
    }
  };

  const handleDownload = async (fileName) => {
    try {
      const token = Cookies.get("authToken");
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/upload/shipmentDocuments/${shipmentNumber}/downloadzip`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Office-Code": officeCode,
          },
          responseType: "blob", // important for downloading
        }
      );

      // Trigger file download
      const blob = new Blob([response.data], { type: "application/zip" });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `documents_${shipmentNumber}.zip`;
      link.click();
    } catch (error) {
      // toast.error("Download failed. Please try again.");
    }
  };

  const openAppointmentFromShipment = async (mode = "add") => {
    // Base validation
    if (!shipmentNumber) {
      notify.error({
        title: "Missing Shipment",
        message: "Cannot process appointment without a shipment number.",
      });
      return;
    }

    // Carriers may only view drop trailer appointments — never add or edit them.
    if (carrierHasDropTrailerStop && mode !== "readonly") {
      if (mode === "add") {
        notify.warning({
          title: "Read-Only Appointment",
          message: "Carriers can only view drop trailer appointments and cannot add them.",
        });
        return;
      }
      // Coerce any edit attempt down to read-only.
      mode = "readonly";
    }

    const requiresExisting = mode === "update" || mode === "readonly";
    
    const rawStopReason = (appointmentData.stopReasonCode || "").trim();
    if (!rawStopReason) {
      notify.warning({
        title: "Stop reason required",
        message: "Please add a stop reason (Live Load or Drop Trailer) before creating an appointment.",
      });
      return;
    }

    let appointment = null;

    // Fetch ONLY when needed (view/edit)
    if (requiresExisting) {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/api/appointment/by-shipment/${shipmentNumber}`
        );

        const appt = response.data;

        if (!appt) {
          notify.error({
            title: "No Appointment",
            message: "No appointment found.",
          });
          return;
        }

        // pick latest valid appointment
        appointment = Array.isArray(appt)
          ? appt
              .filter((a) => !a.cancelled)
              .sort((a, b) =>
                new Date(b.modifiedAt || b.createdAt || 0) -
                new Date(a.modifiedAt || a.createdAt || 0)
              )[0]
          : appt;

        if (!appointment?.appointmentId) {
          notify.error({
            title: "Invalid Appointment",
            message: "Appointment ID is missing.",
          });
          return;
        }
      } catch (err) {
        notify.error({
          title: "Error",
          message: "Failed to retrieve appointment.",
        });
        return;
      }
    }

    // 🚫 ADD / UPDATE shared validation
    if (!requiresExisting) {
      const pickupStop = shipmentDetails?.shipmentStops?.find(
        (s) => s.stopType === "PICKUP"
      );

      if (!appointmentData || !pickupStop) {
        notify.error({
          title: "Missing data",
          message: "No appointment data available.",
        });
        return;
      }

      if (status === "Active") {
        notify.warning({
          title: "Shipment In-Transit",
          message: "Cannot create appointment while active.",
        });
        return;
      }
    }

    const { label, contentType } = APPOINTMENT_MODES[mode];

    // 🧾 Build payload
    let payload;

    if (requiresExisting) {
      payload = {
        ...appointment,
        mode,
      };
    } else {
      // ADD mode payload
      const pickupStop = shipmentDetails?.shipmentStops?.find(
        (s) => s.stopType === "PICKUP"
      );

      const raw = (
        pickupStop?.stopReasonCode ||
        appointmentData?.stopReasonCode ||
        ""
      ).trim().toUpperCase();

      const code =
        raw === "LIVE LOAD" || raw === "LD" ? "LL" :
        raw === "DROP TRAILER" || raw === "DT" ? "DT" :
        raw || "UNK";

      payload = {
        ...appointmentData,
        stopReasonCode: code,
        requestType: code === "DT" ? "DROP_TRAILER" : "LIVE_LOAD",
        isDropTrailer: code === "DT",
        mode,
      };
    }

    // 🏷️ Tab name
    const tabName = requiresExisting
      ? `${payload.shipmentNumber ?? "Appointment"} – ${label}`
      : `${payload.shipmentNumber ?? "—"} – ${label} Appointment`;

    // 🚀 Dispatch
    dispatch(
      addAppointmentTab({
        id: `${mode}-appointment-${payload.appointmentId ?? Date.now()}`,
        name: tabName,
        contentType,
        appointmentData: payload,
        isDynamic: true,
        createdAt: Date.now(),
        mode,
      })
    );
    navigate("/dashboard/appointments");
  };

  // Normalize stopReasonCode once for this render
  const stopCode = React.useMemo(() => {
    const raw = (stopReasonCode ?? "").toString().trim().toUpperCase();
    if (raw === "LIVE LOAD") return "LL";
    if (raw === "DROP TRAILER") return "DT";
    return raw; // "LL", "DT", "LD", etc., or empty
  }, [stopReasonCode]);

  const handleCreateInvoice = async () => {
    try {
      const token = Cookies.get("authToken");
      const officeCode = shipmentDetails?.officeCode;

      // === 1️⃣ Fetch shipment invoice data ===
      const { data } = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/shipments/invoice/${shipmentNumber}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Office-Code": officeCode,
          },
        }
      );

      console.log("📦 Shipment invoice data:", data);

      // === 2️⃣ Validate ===
      if ((data.status || "").toLowerCase() !== "completed") {
        notify.error({
          title: "Invalid Status",
          message: "Invoice can only be created for completed shipments.",
        });
        return;
      }

      if (data.isInvoiced) {
        notify.error({
          title: "Already Invoiced",
          message: `Shipment #${data.shipmentNumber} is already invoiced.`,
        });
        return;
      }

      if (data.paymentMethod === "COLLECT") {
        notify.error({
          title: "Collect Shipment",
          message: `Shipment #${data.shipmentNumber} has payment type 'Collect' and cannot be invoiced.`,
        });
        return;
      }

      // === 3️⃣ Prepare prefilled invoice object ===
      const shipTosFromStops = (data.shipmentStops || [])
        .filter((s) => (s.stopType || "").toUpperCase() === "DROP_OFF")
        .sort((a, b) => (a.stopSequence ?? 0) - (b.stopSequence ?? 0))
        .map((s) => ({
          companyName: s.stopName ?? s.warehouseName ?? null,
          address: s.addressLine1 ?? null,
          address2: s.addressLine2 ?? null,
          city: s.city ?? null,
          state: s.state ?? null,
          zip: s.zipCode ?? null,
          country: s.country ?? null,
          phone: s.contactPhone ?? null,
          email: s.contactEmail ?? null,
          fax: s.contactFax ?? null,
          stopNumber: s.stopNumber ?? null,
          stopSequence: s.stopSequence ?? null,
          stopType: s.stopType ?? null,
        }));

      const shipTos =
        shipTosFromStops.length > 0
          ? shipTosFromStops
          : [
              {
                companyName:
                  data.receiverOfficeCode?.name ?? data.receiverName ?? null,
                address: data.receiverOfficeCode?.addressLine1 ?? null,
                city: data.receiverOfficeCode?.city ?? null,
                state: data.receiverOfficeCode?.state ?? null,
                zip: data.receiverOfficeCode?.zipCode ?? null,
                country: data.receiverOfficeCode?.country ?? null,
                phone: data.receiverOfficeCode?.contactPhone ?? null,
                email: data.receiverOfficeCode?.contactEmail ?? null,
                fax: data.receiverOfficeCode?.contactFax ?? null,
              },
            ];

      const prefilled = [
        {
          shipmentNumber: data.shipmentNumber,
          shipmentOfficeCode: data.officeCode,
          shipmentOrigin: data.portOfOrigin,
          shipmentDestination: data.portOfDestination,
          equipmentNumber: data.isoEquipmentCode,
          shipmentCharge: data.totalCharge,
          charges: (data.charges || []).map((c) => ({
            chargeCode: c.code,
            chargeName: c.chargeName,
            chargeAmount: c.amount,
            chargeCurrency: c.currency,
            chargeType: c.type,
            chargeAuditStatus: c.chargeApprovalStatus,
            isAutoPopulated: true,
          })),
          estimatedCharges: (data.estimatedCharges || []).map((c) => ({
            chargeCode: c.code,
            chargeName: c.chargeName,
            chargeAmount: c.amount,
            chargeCurrency: c.currency,
            chargeType: c.type,
            chargeAuditStatus: c.chargeApprovalStatus,
            isAutoPopulated: false,
          })),

          billToCompanyName: data.shipperOfficeCode?.name,
          billToOfficeCode: data.shipperOfficeCode?.partyOfficeCode,
          billToAddress: data.shipperOfficeCode?.addressLine1,
          billToCity: data.shipperOfficeCode?.city,
          billToState: data.shipperOfficeCode?.state,
          billToZip: data.shipperOfficeCode?.zipCode,
          billToCountry: data.shipperOfficeCode?.country,
          billToPhone: data.shipperOfficeCode?.contactPhone,
          billToEmail: data.shipperOfficeCode?.contactEmail,
          billToFax: data.shipperOfficeCode?.contactFax,

          payToCompanyName: data.carrierName,
          payToOfficeCode: data.carrierOfficeCode?.partyOfficeCode,
          payToAddress: data.carrierOfficeCode?.addressLine1,
          payToCity: data.carrierOfficeCode?.city,
          payToState: data.carrierOfficeCode?.state,
          payToZip: data.carrierOfficeCode?.zipCode,
          payToCountry: data.carrierOfficeCode?.country,
          payToPhone: data.carrierOfficeCode?.contactPhone,
          payToEmail: data.carrierOfficeCode?.contactEmail,
          payToFax: data.carrierOfficeCode?.contactFax,

          shipTos,

          shipToCompanyName: shipTos[0]?.companyName ?? null,
          shipToOfficeCode: data.receiverOfficeCode?.partyOfficeCode ?? null,
          shipToAddress: shipTos[0]?.address ?? null,
          shipToCity: shipTos[0]?.city ?? null,
          shipToState: shipTos[0]?.state ?? null,
          shipToZip: shipTos[0]?.zip ?? null,
          shipToCountry: shipTos[0]?.country ?? null,
          shipToPhone: shipTos[0]?.phone ?? null,
          shipToEmail: shipTos[0]?.email ?? null,
          shipToFax: shipTos[0]?.fax ?? null,
        },
      ];

      dispatch(
        addInvoiceTab({
          id: `invoice-new-${Date.now()}`,
          name: "New Invoice",
          type: "new",
          data: prefilled,
        })
      );
      dispatch(
        setActiveInvoiceTab({
          index: defaultTabs.length + dynamicTabs.length,
        })
      );
      navigate("/dashboard/invoices");
    } catch (err) {
      console.error(err);
      const apiMsg = err.response?.data?.content;
    }
  };
  
  const handleViewInvoice = (invoiceNumber) => {
    try {
      const invoiceData = {
        invoiceNumber: invoiceNumber,
        officeCode: shipmentDetails?.officeCode,
        billToOfficeCode: shipmentDetails?.shipperOfficeCode?.partyOfficeCode || "",
        billToCompanyName: shipmentDetails?.shipperName || "",
        payToOfficeCode: shipmentDetails?.carrierOfficeCode?.partyOfficeCode || "",
        payToCompanyName: shipmentDetails?.carrierName || "",
        currency: shipmentDetails?.currency || "USD",
        total: shipmentDetails?.totalCharge || 0,
        invoiceStatus: shipmentDetails?.invoiceStatus || "",
        invoiceDate: shipmentDetails?.invoiceDate || "",
        shipments: shipmentDetails?.shipmentNumber ? [{
          shipmentNumber: shipmentDetails.shipmentNumber,
          officeCode: shipmentDetails.officeCode
        }] : []
      };
      // dispatch(
      //   addInvoiceTab({
      //     id: `invoice-view-${invoiceNumber}-${Date.now()}`,
      //     name: `Invoice ${invoiceNumber}`,
      //     type: "edit",
      //     data: invoiceData,
      //   })
      // );

      const tabKey = `edit-${invoiceNumber}-${Date.now()}`;
      dispatch(
        addInvoiceTab({
          id: tabKey,
          name: invoiceNumber,
          type: "edit",
          // data: { 
          //   invoiceNumber,
          //   billToOfficeCode: shipmentDetails?.officeCode || officeCode
          // }
          data:invoiceData,        })
      );
      
      dispatch(
        setActiveInvoiceTab({
          index: defaultTabs.length + dynamicTabs.length,
        })
      );
      
      navigate("/dashboard/invoices");
      
    } catch (err) {
      console.error("Failed to open invoice:", err);
      notify.error({
        title: "Error",
        message: "Failed to open invoice.",
      });
    }
  };
  // Permission helpers
  // const U = (s) => (s ?? "").toString().trim().toUpperCase();
  const can = (name) => hasAllowedAction(allowedActions, name);
  const canAny = (...names) => names.some((n) => can(n));
  const canAction = (suffix) => can(`Action/${suffix}`);
  const buttons = [];
  const isTerminal = [
    "Completed",
    "Cancelled",
    "Canceled",
    "Recalled",
  ].includes(status);
  const isActive = ["Active"].includes(status);
  const [showRejectModal, setShowRejectModal] = useState(false);
  const { tabs: locationTabs } = useSelector(selectModuleTabs("locations"));
  const carrierHasDropTrailerStop = isCarrier && stopCode === "DT";

  const normalizeLocationFromResponse = (raw) => {
    const location = Array.isArray(raw) ? raw[0] : raw;
    if (!location) return null;
    return {
      ...location,
      contactPerson:
        location.contactPerson ??
        location.contactName ??
        location.contact ??
        "",
    };
  };

  const openLocationTabForStop = async (stop, stopIndex) => {
    const payload = {
      locationName: stop.stopName || null,
      addressLine1: stop.addressLine1 || null,
      addressLine2: stop.addressLine2 || null,
        customLocationERP: stop.locationERPIdentifier || null,
      city: stop.city || null,
      state: stop.state || null,
      zipCode: stop.zipCode || null,
      country: stop.country || null,
    };

    try {
      const { data } = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/locations/search`,
        payload,
        { headers: { accept: "*/*", "Content-Type": "application/json" } }
      );
      const locationData = normalizeLocationFromResponse(data);
      if (!locationData) {
        throw new Error("No location returned");
      }

      dispatch(
        addLocationTab({
          id: `view-location-${stop.id || stopIndex}-${Date.now()}`,
          name: `${stop.stopName || `Stop ${stopIndex + 1}`} • Location`,
          contentType: "locationView",
          locationId: locationData?.id || null,
          data: locationData,
          isDynamic: true,
          createdAt: Date.now(),
        })
      );
      dispatch(setLocationActiveTab({ index: locationTabs.length }));
      navigate("/dashboard/locations");
    } catch (err) {
      console.error("Location lookup failed", err);
      notify.error({
        title: "Location Lookup Failed",
        message: "Unable to load location details for this stop.",
      });
    }
  };

  async function handleDownloadShipmentPdf() {
    const officeCodeHeader =
      shipmentDetails?.officeCode ||
      shipmentOfficeCode ||
      (manyOfficeCodes ? manyOfficeCodes.split(",")[0]?.trim() : null);
    const authToken = Cookies.get("authToken");
    if (!officeCodeHeader) {
      notify.error({
        title: "Missing office code",
        message: "Office code is required to generate the PDF.",
      });
      return;
    }
    if (!authToken) {
      notify.error({
        title: "Not authenticated",
        message: "Sign in again to download the shipment PDF.",
      });
      return;
    }
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/shipments/${shipmentNumber}/print`,
        {
          responseType: "blob",
          headers: {
            "Office-Code": officeCodeHeader,
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      const blob = new Blob([data], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `shipment-${shipmentNumber}.pdf`;
      link.click();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error("Failed to download shipment PDF", err);
      notify.error({
        title: "Download failed",
        message: "Unable to generate the shipment PDF right now.",
      });
    }
  }

  // Re-Plan (treat Plan/Re-Plan the same)
  if (
    !isTerminal &&
    // shipmentDetails?.paymentMethod !== "COLLECT" &&  //collect should show plan shipment
    canAny("Plan Shipment", "Re Plan Shipment", "Re-Plan Shipment")
  ) {
    const label = status !== "New" ? "Re-Plan Shipment" : "Plan Shipment";
    buttons.push({
      label,
      type: label !== "Plan Shipment" ? "Secondary" : "primary",
      onClick: () => setShowModal(true),
    });
  }

  // Add Stop Reason (carrier often has this in Active)
  if (!isTerminal && can("Add Stop Reason")) {
    buttons.push({
      label: "Add Stop Reason",
      type: "primary",
      onClick: () => setShowStopReasonModal(true),
    });
  }

  // Helper function to get available stops for actuals
  const getAvailableStopsForActuals = (stopType) => {
    if (!shipmentDetails?.shipmentStops) return [];
    console.log(shipmentDetails.shipmentStops);

    return shipmentDetails.shipmentStops.filter((stop) => {
      // Only show stops that don't already have actuals
      const hasActuals = stop.actualGateIn && stop.actualGateOut;
      return stop.stopType === stopType && !hasActuals;
    });
  };

  // Add Actual Pickup
  if (
    !isTerminal &&
    canAny("Add Actual Pickup", "Add Actual PickUp", "Add Actual Pick Up")
  ) {
    const availablePickupStops = getAvailableStopsForActuals("PICKUP");
    console.log(availablePickupStops);
    if (availablePickupStops.length > 0) {
      buttons.push({
        label: "Add Actual Pickup",
        type: "primary",
        onClick: () =>
          setShowActualsModal({
            open: true,
            mode: "pickup",
            availableStops: availablePickupStops,
          }),
      });
    }
  }

  // Add Actual Dropoff
  if (
    !isTerminal &&
    canAny("Add Actual Dropoff", "Add Actual DropOff", "Add Actual Drop Off")
  ) {
    const availableDropoffStops = getAvailableStopsForActuals("DROP_OFF");
    if (availableDropoffStops.length > 0) {
      buttons.push({
        label: "Add Actual Dropoff",
        type: "primary",
        onClick: () =>
          setShowActualsModal({
            open: true,
            mode: "dropoff",
            availableStops: availableDropoffStops,
          }),
      });
    }
  }
    const role = useMemo(
      () => inferRoleForShipment(shipmentDetails, manyOfficeCodes),
      [shipmentDetails, manyOfficeCodes]
    );

  // Derived synchronously from shipmentDetails (same source as `role`) so the
  // View/Edit appointment label is decided in the same render `role` enables the
  // button. Relying on the `isCarrier`/`stopReasonCode` state here caused a
  // brief "Edit Appointment" flicker before "View Appointment".
  const carrierHasDropTrailerStopForLabel = useMemo(() => {
    if (role !== "carrier") return false;
    const pickupStop = shipmentDetails?.shipmentStops?.find(
      (stop) => stop.stopType === "PICKUP"
    );
    const raw = (pickupStop?.stopReasonCode ?? "").toString().trim().toUpperCase();
    return raw === "DT" || raw === "DROP TRAILER";
  }, [role, shipmentDetails]);


  const shipperCanAccessAppt = role === "shipper";
  const carrierCanAccessAppt = role === "carrier";
  const userCanAccessAppt    = shipperCanAccessAppt || carrierCanAccessAppt;
  if (!isTerminal && userCanAccessAppt) {
    const apptExists  = shipmentDetails?.isAppointmentCreated;
    const isInTransit = ["Active", "Completed"].includes(status);

    if (isInTransit) {
      // In-transit appt is read-only if it exists
      if (apptExists) {
        buttons.push({
          label:   "View Appointment",
          type:    "primary",
          onClick: () => openAppointmentFromShipment("readonly"),
        });
      }
    } else if (apptExists) {
      // Appointment exists, shipment not yet in-transit → editable.
      // Carriers can only view (never edit) drop trailer appointments.
      buttons.push(
        carrierHasDropTrailerStopForLabel
          ? {
              label:   "View Appointment",
              type:    "primary",
              onClick: () => openAppointmentFromShipment("readonly"),
            }
          : {
              label:   "Edit Appointment",
              type:    "primary",
              onClick: () => openAppointmentFromShipment("update"),
            }
      );
    } else if (can("New Appointment") && !carrierHasDropTrailerStopForLabel) {
      // Carriers cannot add drop trailer appointments — view-only access.
      buttons.push({
        label:   "Add Appointment",
        type:    "primary",
        onClick: () => openAppointmentFromShipment("add"),
      });
    }
  }

  // Tender
  if (can("Tender") && !isTerminal) {
    buttons.push({
      label: "Tender",
      type: "primary",
      onClick: () => handleTender(shipmentNumber, fetchShipmentDetails),
    });
  }

  // Accept
  if (!isTerminal && canAny("Accept", "Accept Shipment")) {
    buttons.push({
      label: "Accept",
      type: "primary",
      onClick: () => {
        setProModalMode("accept");
        setShowProModal(true);
      },
    });
  }

  // Reject (handle naming variants just in case)
  // if (!isTerminal && canAny("Reject", "Decline", "Reject Shipment")) {
  //   buttons.push({
  //     label: "Reject",
  //     type: "destructive",
  //     onClick: () =>
  //       handleReject(shipmentNumber, fetchShipmentDetails, "Rejected", "reject-shipment"),
  //   });
  // }

  if (!isTerminal && canAny("Reject", "Decline", "Reject Shipment")) {
    buttons.push({
      label: "Reject",
      type: "destructive",
      onClick: () => setShowRejectModal(true),
    });
  }

  //Create Invoice
  if (
    (
      canAny("Create Invoice", "Generate Invoice") ||
      canAction("Create Invoice")
    ) &&
    (shipmentDetails?.paymentMethod?.toLowerCase() !== "collect") &&
    !shipmentDetails?.isInvoiced  // ✅ Add this check
  ) {
      buttons.push({
        label: "Create Invoice",
        type: "primary",
        onClick: handleCreateInvoice,
      });
    }

    if (
      shipmentDetails?.isInvoiced && 
      shipmentDetails?.invoiceNumber &&
      shipmentDetails?.paymentMethod?.toLowerCase() !== "collect"
    ) {
      buttons.push({
        label: "View Invoice",
        type: "primary",
        onClick: () => handleViewInvoice(shipmentDetails.invoiceNumber),
      });
    }

  const handleRefreshRatesClick = () => {
    if (isRefreshBlockedForShipment(shipmentDetails)) {
      notify.warning({ title: "Action Blocked", message: REFRESH_RATES_BLOCKED_MESSAGE });
    } else if (shipmentDetails?.invoiceNumber) {
      setShowRefreshRatesWarning(true); // show warning if invoiced
    } else {
      handleRefreshRates(); // proceed directly if not invoiced
    }
  };

  const handleRefreshRates = useCallback(
    () =>
      refreshRatesAndUpdateCharges({
        shipmentDetails,
        officeCode,
        isRefreshingRates,
        setIsRefreshingRates,
        // Wrap setShipmentDetails to also update header bar (infoData)
        // because header reads from infoData, not shipmentDetails directly
        setShipmentDetails: (updatedShipment) => {
              // 1. Update shipment details section as normal
              setShipmentDetails(updatedShipment);

        // Update infoData so the header reflects the new totalCharge
        setInfoData((prev) => ({
          ...prev,
          "Total Charge": {
            type: "text",
            value: formatMoney(updatedShipment.totalCharge)
          },
        }));
      },
    }),
  [shipmentDetails, officeCode, isRefreshingRates, setIsRefreshingRates, setShipmentDetails]
  );

  const handleRefreshMilesClick = () => {
  if (isRefreshBlockedForShipment(shipmentDetails)) {
    notify.warning({ title: "Action Blocked", message: REFRESH_MILES_BLOCKED_MESSAGE });
  } else if (shipmentDetails?.invoiceNumber) {
    setShowRefreshMilesWarning(true); // show warning if invoiced
  } else {
    handleRefreshMiles(); // proceed directly if not invoiced
  }
  };


  const handleRefreshMiles = async () => {
  setIsRefreshingMiles(true);
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/api/shipments/refresh-transit-miles`,
      { shipmentNumbers: [shipmentNumber] },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Office-Code": officeCode,
        },
      }
    );

      const { totalFound, successfullyUpdated, failed, noChange, failures } = response.data;
      notify.success({
        title: "Miles Refreshed",
        message: `Total: ${totalFound} | Updated: ${successfullyUpdated} | Unchanged: ${noChange} | Failed: ${failed}`,
        options: { autoClose: 4000 }  // ← 4 seconds
      });

      if (failed > 0) {
        const failedNumbers = failures?.map(f => f.shipmentNumber).join(", ");
        notify.error({
          title: `${failed} Shipment(s) Failed`,
          message: failedNumbers,
        });
      }
      await fetchShipmentDetails(); // refresh the view to show updated miles
    } catch (err) {
      notify.error({
        title: "Refresh Failed",
        message: err?.response?.data?.message || "Could not refresh miles.",
      });
    } finally {
      setIsRefreshingMiles(false);
    }
  };

  // Action dropdown (only include what the API returned)
  const actions = [];
  if (canAction("Add Stops"))
    actions.push({
      label: "Add Stops",
      icon: <Plus size={16} className="text-gray-600" />,
      onClick: () => setShowAddStopModal(true),
    });
  if (canAction("Recall"))
    actions.push({
      label: "Recall",
      icon: <Undo2 size={16} className="text-gray-600" />,
      onClick: () => setShowRecallModal(true),
    });
  if(isShipperOrg)  {
  if (canAction("Reorder Stops") && isAdminUser)
    actions.push({
      label: "Reorder Stops",
      icon: <Shuffle size={16} className="text-gray-600" />,
      onClick: () => setShowReorderModal(true),
    });
  }
  if (canAction("Cancel") && !isTerminal && !isActive)
    actions.push({
      label: "Remove Orders",
      icon: <Unlink size={16} className="text-gray-600" />,
      onClick: () => setShowRemoveOrdersModal(true),
    });
  if (canAction("Cancel") && !isTerminal && !isActive)
    actions.push({
      label: "Cancel Shipment",
      icon: <XCircle size={16} className="text-gray-600" />,
      onClick: () => setShowCancelShipmentModal(true),
    });
  if (isShipperOrg) {
    const isRefreshBlocked = isRefreshBlockedForShipment(shipmentDetails);
    actions.push({
      label: isRefreshingRates ? "Refreshing..." : "Refresh Rates",
      icon: isRefreshingRates ? (
        <Loader2 size={16} className="text-gray-600 animate-spin" />
      ) : (
        <RefreshCcw size={16} className="text-gray-600" />
      ),
      onClick: handleRefreshRatesClick,
      muted: isRefreshBlocked,
    });

    actions.push({
    label: isRefreshingMiles ? "Refreshing..." : "Refresh Miles",
    icon: isRefreshingMiles ? (
      <Loader2 size={16} className="text-gray-600 animate-spin" />
    ) : (
      <RefreshCcw size={16} className="text-gray-600" />
    ),
    onClick: handleRefreshMilesClick,
    muted: isRefreshBlocked,
  });
  }

  if (actions.length) {
    buttons.push({
      label: "Action",
      type: "dropdown",
      color: "red",
      options: actions,
    });
  }

  // // 6) Optional: New Appointment if your API returns that key
  // if (!isTerminal && can("New Appointment")) {
  //   buttons.push({
  //     label: "New Appointment",
  //     type: "primary",
  //     onClick: () => openNewAppointmentFromShipment(),
  //   });
  // }

  // 7) Optional: Assign/Re-Assign Carrier (if your API has such keys)
  if (
    !isTerminal &&
    shipmentDetails?.paymentMethod === "COLLECT" && //  only for collect
    isAdminUser && isShipper &&//  show only if user has admin role
    (can("Assign Carrier") || can("Re-Assign Carrier"))
  ) {
    const assignLabel = can("Re-Assign Carrier")
      ? "Re-Assign Carrier"
      : "Assign Carrier";
    buttons.push({
      label: assignLabel,
      type: assignLabel.startsWith("Re-") ? "Secondary" : "primary",
      onClick: () => setShowReceiverCarrierModal(true),
    });
  }

  const handleInfoChange = (field, newValue) => {
    setInfoData((prev) => ({
      ...prev,
      [field]: {
        ...prev[field],
        value: newValue,
      },
    }));
  };

  // Fetch data when shipmentNumber changes
  useEffect(() => {
    if (shipmentNumber) {
      fetchShipmentDetails();
    }
    return () => abortControllerRef.current.abort();
  }, [shipmentNumber, fetchShipmentDetails]);

  // Rest of your component code remains the same until loading state...
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return `${date.getFullYear()}-${(date.getMonth() + 1)
      .toString()
      .padStart(2, "0")}-${date.getDate().toString().padStart(2, "0")}`;
  };

  const setSectionRef = (sectionName) => (el) => {
    sectionRefs.current[sectionName] = el;
  };

  const handleFileSelect = (e) => {
    const files = Array.from(e.target.files);
    setSelectedFiles((prev) => [...prev, ...files]);
  };

  const removeFile = (indexToRemove) => {
    setSelectedFiles((prev) => prev.filter((_, idx) => idx !== indexToRemove));
  };

  useEffect(() => {}, [activeSection]);

  if (!shipmentDetails) {
    return (
      <div className="p-4 flex items-center justify-center h-full w-full">
        <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-blue-600" />
      </div>
    );
  }

  const handleRecallConfirm = async (reason) => {
    const currentIndex = activeTabIndex; // remember which tab we’re in now
    // handleReject now owns the success/error toast for both the reject and recall
    // paths (it used to swallow failures silently with no feedback at all), so this
    // just awaits it and closes the modal either way.
    await handleReject(
      shipmentNumber,
      fetchShipmentDetails,
      "Unassigned",
      "recall-shipment",
      reason,
      false    //Don't close tab
    );
    setShowRecallModal(false);
    // } finally {
    //   // close the modal
    //   setShowRecallModal(false);

    //   // jump to "Shipment List" (assumes index 0 is the default list tab)
    //   dispatch(setActiveTab({ index: 0 }));

    //   // close the old details tab
    //   dispatch(removeTab({ tabIndex: currentIndex }));
    // }
  };

  const handleCancelAndExit = async () => {
    const currentIndex = activeTabIndex; // remember which tab we’re in now
    try {
      const res = await handleCancelOrRemove(
        shipmentNumber,
        orderNumber,
        true,
        ""
      );
    } finally {
      // close the modal
      setShowCancelShipmentModal(false);

      // jump to "Shipment List" (assumes index 0 is the default list tab)
      dispatch(setActiveTab({ index: 0 }));

      // close the old details tab
      dispatch(removeTab({ tabIndex: currentIndex }));
    }
  };

  const handleRemoveOrdersConfirm = async (selectedSoCsv) => {
    const currentIndex = activeTabIndex; // remember which tab we’re in now
    try {
      const res = await handleCancelOrRemove(
        shipmentNumber,
        orderNumber,
        false,
        selectedSoCsv
      );
    	setShowRemoveOrdersModal(false);  // Close modal (shows success)
    } catch (error) {
    // If error: modal stays open, user can retry
    setShowRemoveOrdersModal(false);  // Optional: close on error too
    toast.error(error.message);
  }
    
    // finally {
    //   // close the modal
    //   setShowRemoveOrdersModal(false);

    //   // jump to "Shipment List" (assumes index 0 is the default list tab)
    //   dispatch(setActiveTab({ index: 0 }));

    //   // close the old details tab
    //   dispatch(removeTab({ tabIndex: currentIndex }));
    // }
  };

  /** Button Actions */
  // Update shipment status for a given shipment number.
  // Updated updateShipmentStatus function
  const updateShipmentStatus = async (
    shipmentNumber,
    updateObject,
    fetchShipmentDetails,
    triggeredBy = null,
    reason = null
  ) => {
    try {
      const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${Cookies.get("authToken")}`,
        "Office-Code": shipmentOfficeCode,
      };

      if (triggeredBy) {
        headers["triggered-by"] = triggeredBy;
      }

      if (reason) {
        headers["x-reason"] = reason;
      }

      const response = await axios.put(
        `${process.env.REACT_APP_API_BASE_URL}/api/shipments/${shipmentNumber}`,
        updateObject,
        { headers }
      );

      // Wait for refetch to complete before resolving
      await fetchShipmentDetails();
      await fetchActivityLogs();

      return response;
    } catch (error) {
      console.error(
        `Error updating shipment status to ${JSON.stringify(updateObject)}:`,
        error
      );
      throw error; // Rethrow to be caught in handleTender
    }
  };

  // Add these functions in your handler functions section

  const handleUpload = async () => {
    if (!file || !fileType) {
      // toast.warn("Please select a file and file type");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);
    formData.append("fileType", fileType);

    const token = Cookies.get("authToken");

    try {
      setIsUploading(true);
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/upload/shipmentDocuments/${shipmentNumber}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Office-Code": officeCode,
          },
        }
      );

      // Assuming the response contains the filename of the uploaded document
      const match = /File (.+?) added/.exec(response.data);
      if (match) {
        const newDocument = match[1]; // Extracted document name

        // Update the uploadedDocs array with the newly uploaded document
        setUploadedDocs((prevDocs) => [...prevDocs, newDocument]);
      }

      // toast.success("Document uploaded successfully");
      fetchShipmentDetails(); // Optionally, fetch updated shipment details if necessary
    } catch (error) {
      console.error("Upload failed", error);
      // toast.error(
      //   error.response?.data?.message || "Upload failed. Please try again."
      // );
    } finally {
      setIsUploading(false);
    }
  };

  const handleTender = async (shipmentNumber, fetchShipmentDetails) => {
    try {
      const updatedShipmentStatus = { status: "Tendered" };
      await updateShipmentStatus(
        shipmentNumber,
        updatedShipmentStatus,
        fetchShipmentDetails,
        "tender-shipment"
      );
      // Pull a nice display name with sensible fallbacks
      const carrierName =
        shipmentDetails?.carrierOfficeCode?.name ||
        shipmentDetails?.carrierName ||
        shipmentDetails?.carrierOfficeCode?.partyOfficeCode ||
        "";

      notify.success({
        title: "Shipment tendered",
        message: `#${shipmentNumber} sent to carrier${
          carrierName ? ` ${carrierName}` : ""
        }`,
      });
    } catch (error) {
      notify.error({ title: "Tender failed", message: "Please try again." });
    }
  };

  const handleAcceptWithProNumber = async (proNumber) => {
    try {
      await updateShipmentStatus(
        shipmentNumber,
        { status: "Accepted", proNumber: proNumber },
        fetchShipmentDetails
      );
      notify.success({
        title: "Shipment Accepted",
        message: `#${shipmentNumber} with PRO #${proNumber}`,
        // options: { autoClose: 2200 } // optional override
      });
    } catch (err) {
      // Error toast
      notify.error({
        title: "Accept Failed",
        message:
          err?.response?.data?.message ||
          err?.message ||
          "Something went wrong.",
      });
    }
  };

  const handleUpdateProNumber = async (newProNumber) => {
    try {
      await updateShipmentStatus(
        shipmentNumber,
        { proNumber: newProNumber },
        fetchShipmentDetails
      );
      notify.success({
        title: "Success",
        message: "PRO Number updated successfully",
      });
    } catch (err) {
      const errorData = err?.response?.data;
      let errorMessage = "Failed to update PRO Number";

      if (errorData && typeof errorData === 'object' && errorData.content) {
        errorMessage = errorData.content;
      } else if (errorData?.message) {
        errorMessage = errorData.message;
      } else if (err?.message) {
        errorMessage = err.message;
      }

      notify.error({
        title: "Error",
        message: errorMessage,
      });
      throw err;
    }
  };
  const handleReject = async (
    shipmentNumber,
    fetchShipmentDetails,
    status,
    triggeredBy,
    reason,
    shouldCloseTab = true  // NEW PARAMETER with default true
  ) => {
    // For Carriers only: clicking 'Reject' updates status to "Rejected".
    const updatedShipmentStatus = { status: status };
    try {
      const response = await updateShipmentStatus(
        shipmentNumber,
        updatedShipmentStatus,
        fetchShipmentDetails,
        triggeredBy,
        reason
      );

      const data = response.data;
      if (data === "MANUAL") {
        await fetch(
          `${process.env.REACT_APP_API_BASE_URL}/api/shipment-charges-update/reset-charges/${shipmentNumber}`,
          {
            method: "PUT",
            headers: {
              Authorization: `Bearer ${token}`,
              "Office-Code": officeCode,
              "Content-Type": "application/json",
            },
          }
        );
        // Only close tab if requested
        if (shouldCloseTab) {
          dispatch(removeTab({ tabIndex: activeTabIndex }));
        }
      } else {
        if (triggeredBy === "recall-shipment") {
          if (data === "AUTO_ASSIGNED") {
            notify.success({
              title: "Shipment recalled",
              message: "Carrier is automatically selected as configured in the route.",
            });
          } else if (data === "AUTO_ASSIGNED_AUTO_TENDERED") {
            notify.success({
              title: "Shipment recalled",
              message: "Carrier is automatically selected and tendered as configured in the route.",
            });
          } else {
            notify.success({ title: "Shipment recalled" });
          }
        } else {
          notify.success({ title: "Shipment rejected" });
        }
        // Only close tab if requested
        if (shouldCloseTab) {
          dispatch(removeTab({ tabIndex: activeTabIndex }));
        }
      }
    } catch (error) {
      notify.error({
        title: triggeredBy === "recall-shipment" ? "Recall failed" : "Reject failed",
        message:
          error?.response?.data?.message || error?.message || "Please try again.",
      });
    }
  };

  const handleCancelOrRemove = async (
    shipmentNumber,
    dbOrderCsv, // the EXACT string as stored in DB: "A1095082,A1095081,A1095085,A1095086"
    isCancel, // true = detach all; false = detach only selected
    selectedSoCsv // user-selected SOs to detach (CSV): "A1095082,A1095081"
  ) => {
    const splitCSV = (csv) => {
      if (!csv) return [];
      return Array.from(
        new Set(
          csv
            .split(",")
            .map((s) => s.trim())
            .filter(Boolean)
        )
      );
    };

    // Build the list to detach
    const soListToDetach = isCancel
      ? splitCSV(dbOrderCsv) // all from DB
      : splitCSV(selectedSoCsv); // only selected

    if (!isCancel && soListToDetach.length === 0) {
      throw new Error("Please select at least one order to detach.");
    }

    const payload = {
      //csvOrderNumber: (dbOrderCsv ?? "").trim(),
      csvOrderNumber: soListToDetach.join(','),
      orderNumbersToDelete: soListToDetach,
      cancellingShipment: Boolean(isCancel),
    };

    let res;
    if (!isCancel) {
      res = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/api/shipments/${shipmentNumber}/detach-orders`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Office-Code": officeCode,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );
    } else {
      res = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/api/shipments/${shipmentNumber}/cancel`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Office-Code": officeCode,
            "Content-Type": "application/json",
          },
        }
      );
    }

    if (!res.ok) {
      let msg = `Request failed (${res.status})`;
      try {
        const data = await res.json();
        msg =
          data?.message ||
          data?.content ||
          (typeof data === "string" ? data : msg);
      } catch {}
      throw new Error(msg);
    }
   // Show toast message
   notify.success({
    title: isCancel ? "All Orders Removed" : "Order Removed",
    message: isCancel
      ? "All orders were successfully removed"
      : `Order ${soListToDetach.join(", ")} ${soListToDetach.length === 1 ? 'was' : 'were'} successfully removed`
  });
  // Refresh shipment data to show updated order list
  await fetchShipmentDetails();
    // // Close the tab
    // dispatch(removeTab({ tabIndex: activeTabIndex }));
  };

  // inside your component, before the return
  const statusValue = infoData.Status?.value;
  const displayStatus = (() => {
    const s = (statusValue ?? "").toLowerCase();
    if (s === "active") return "In-Transit";
    if (s === "completed") return "Delivered";
    return infoData.Status?.value;
  })();

  // should we show the modal‐launcher button?
  const showActualsButton =
    !isCompleted &&
    ((statusValue === "Accepted" && isShipper) ||
      (statusValue === "Ready for Pickup" && (isShipper || isCarrier)) ||
      (statusValue === "Active" && isCarrier));

  // Determine which modal to show based on status
  //mchang: come back to this if-else logic
  const handleModalClick = () => {
    if (statusValue === "Ready for Pickup") {
      setShowStopReasonModal(true);
    } else {
      setShowActualsModal(true);
    }
  };

  // your config object (only needed when we're showing it)
  const saveTemplateConfig = showActualsButton
    ? { type: "button", onClick: handleModalClick }
    : null;

  const handleStopReasonAdded = (stopReasonCode) => {
    console.log("handleStopReasonAdded called");
    // Find the pickup stop
    const pickupStop = shipmentDetails?.shipmentStops?.find(
      (stop) => stop.stopType === "PICKUP"
    );
    if (!pickupStop) return;

    const updatedAppointmentData = {
      ...appointmentData,
      stopReasonCode: pickupStop.stopReasonCode,
    };

    setAppointmentData(updatedAppointmentData);
    console.log(
      "🚚 Appointment Data:being send to appointmet",
      appointmentData
    );
    setStopReasonCode(stopReasonCode);
    console.log("🚚 Shipper View");
    console.log("stopReasonCode:", stopReasonCode); // This is what you're setting
    console.log("status:", status);
  };

  const fieldMap = (label) => {
    const map = {
      "Address Line 1": "addressLine1",
      "Address Line 2": "addressLine2",
      City: "city",
      State: "state",
      "Zip Code": "zipCode",
      Site: "locationERPIdentifier",
      "Appointment Start": "appointmentStart",
      "Appointment End": "appointmentEnd",
      "Actual Gate-In": "actualGateIn",
      "Actual Gate-Out": "actualGateOut",
      "Ready for Pickup Date Time": "readyForPickupDateTime",
      "Stop Reason": "stopReasonCode",
      "Sales Order Numbers": "salesOrderNumbers",
      "PO Numbers": "poNumbers",
      "Total Pallets": "stopOrderTotalPallets",
      "Total Weight": "stopOrderTotalWeight",
      "Total Weight Unit": "stopOrderTotalWeightUnit",
      "Total Volume": "stopOrderTotalVolume",
      "Total Volume Unit": "stopOrderTotalVolumeUnit"
    };
    return map[label];
  };

  const handleStopAdded = async (newStop) => {
    console.log("🚛 New Stop Added:", newStop);
    // Optimistically update UI
    setShipmentDetails((prev) =>
      prev
        ? {
            ...prev,
            shipmentStops: [...(prev.shipmentStops || []), newStop],
          }
        : prev
    );

    try {
      const token = Cookies.get("authToken");
      // const officeCode = Cookies.get("officeCode");

      // Add required fields that backend might expect
      const enrichedStop = {
        ...newStop,
        stopNumber: (shipmentDetails?.shipmentStops?.length || 0) + 1,
        // createdDate: new Date().toISOString(),
        // createdBy: "Current User", // You might want to get this from user context
        // updatedDate: new Date().toISOString(),
        // updatedBy: "Current User",
        // Add any other required fields your backend expects
      };

      await axios.post(
        `${
          process.env.REACT_APP_API_BASE_URL
        }/api/stops/add-stops-to-shipment?shipmentNumber=${encodeURIComponent(
          shipmentDetails.shipmentNumber
        )}`,
        [enrichedStop], // Send just the stops array in the body
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
            "Office-Code": officeCode,
          },
        }
      );
      // toast.success("Stop added successfully!");
      fetchShipmentDetails(); // Refresh details from backend
    } catch (error) {
      console.error("Failed to add stop:", error);
      console.error("Error response:", error.response?.data);
      // toast.error(
      //   error.response?.data?.message || "Failed to add stop. Please try again."
      // );
    }
  };
  const formatMoney = (amount, currency) => {
    if (amount == null || amount === "") return null;
    const n = Number(amount);
    if (Number.isNaN(n)) return null;

    const safe =
      typeof currency === "string" ? currency.trim().toUpperCase() : "";
    const code = /^[A-Z]{3}$/.test(safe) ? safe : "USD";

    try {
      return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: code,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(n);
    } catch {
      return `${n.toFixed(2)} ${code}`; // ultra-defensive
    }
  };

  const handleEditStop = (stop, stopKey) => {
    if (stopKey) {
      setExpandedStops((prev) => ({
        ...prev,
        [stopKey]: true,
      }));
    }

    setEditedStops((prev) => {
      const isEditing = !!prev[stop.id];
      if (isEditing) {
        const updated = { ...prev };
        delete updated[stop.id];
        setIsEditMode(false);
        return updated;
      } else {
        setIsEditMode(true);
        return { ...prev, [stop.id]: { ...stop } };
      }
    });
  };

  const handleStopReasonChange = (stopId, code) => {
    const normalizedCode = code || null;
    const selected = stopReasonOptions.find((opt) => opt.code === normalizedCode);
    setEditedStops((prev) => ({
      ...prev,
      [stopId]: {
        ...prev[stopId],
        stopReasonCode: normalizedCode,
        stopReasonName: normalizedCode ? selected?.description : undefined,
        hasChanges: true,
      },
    }));
    setOpenStopReasonDropdown(null);
  };

  // ==== Time conversion helpers ====
  const toLocalInputValue = (isoString) => {
    if (!isoString) return "";
    const parts = isoString.split(/[-T:]/);
    const [y, m, d, h, min] = parts.map((n) => parseInt(n, 10));
    const sec = parts[5] ? parseInt(parts[5], 10) : 0;
    const local = new Date(y, m - 1, d, h, min, sec);
    return `${local.getFullYear()}-${String(local.getMonth() + 1).padStart(2, "0")}-${String(local.getDate()).padStart(2, "0")}T${String(local.getHours()).padStart(2, "0")}:${String(local.getMinutes()).padStart(2, "0")}:${String(local.getSeconds()).padStart(2, "0")}`;
  };

  const fromLocalInputValue = (localValue) => {
    if (!localValue) return null;
    const colonCount = (localValue.match(/:/g) || []).length;
    return colonCount >= 2 ? localValue : `${localValue}:00`;
  };
  const FUTURE_LIMIT_MS = 3 * 60 * 60 * 1000;
  const nowLocalInput = toLocalInputValue(new Date().toISOString());
  const futureLimitLocalInput = toLocalInputValue(
    new Date(Date.now() + FUTURE_LIMIT_MS).toISOString()
  );
  const pickupActualGateOut =
    shipmentDetails?.shipmentStops?.find(
      (s) => s.stopType === "PICKUP" && s.actualGateOut
    )?.actualGateOut || null;
  const pickupActualGateOutLocal = toLocalInputValue(pickupActualGateOut);
  const handleStopFieldChange = (stopId, field, value) => {
    setEditedStops((prev) => ({
      ...prev,
      [stopId]: {
        ...prev[stopId],
        [field]: value,
        hasChanges: true, // ✅ track per-stop change
      },
    }));
  };

  const handleRevertStopChanges = (stopId) => {
    setEditedStops((prev) => {
      const updated = { ...prev };
      delete updated[stopId];
      return updated;
    });
    setIsEditMode(false);
  };

  const handleSaveStopChanges = async (stopId) => {
    setIsSavingStopChanges(true);

    const hasProp = (obj, key) =>
      obj && Object.prototype.hasOwnProperty.call(obj, key);

    const toNullIfCleared = (v) => {
      // treat undefined, null, "" as cleared
      if (v === undefined || v === null || v === "") return null;
      return v;
    };


    try {
      const token = Cookies.get("authToken");
      const officeCode = shipmentDetails?.officeCode;

      const stop = editedStops[stopId];
      if (!stop?.hasChanges) return;

      const gateInTime = stop.actualGateIn
        ? new Date(stop.actualGateIn).getTime()
        : null;
      const gateOutTime = stop.actualGateOut
        ? new Date(stop.actualGateOut).getTime()
        : null;

      const futureLimitMs = Date.now() + FUTURE_LIMIT_MS;
      if (
        (gateInTime && gateInTime > futureLimitMs) ||
        (gateOutTime && gateOutTime > futureLimitMs)
      ) {
        notify.error({
          title: "Invalid Actuals",
          message: "Actual times cannot be more than 3 hours in the future.",
        });
        return;
      }

      if (gateInTime && gateOutTime && gateOutTime < gateInTime) {
        notify.error({
          title: "Invalid Actuals",
          message: "Actual Gate-Out cannot be earlier than Actual Gate-In.",
        });
        return;
      }

      if (stop.stopType === "DROP_OFF" && pickupActualGateOut) {
        const pickupOutTime = new Date(pickupActualGateOut).getTime();
        if (
          (gateInTime && gateInTime < pickupOutTime) ||
          (gateOutTime && gateOutTime < pickupOutTime)
        ) {
          notify.error({
            title: "Invalid Actuals",
            message:
              "Dropoff actuals cannot be earlier than the Pickup Actual Gate-Out.",
          });
          return;
        }

        // Block adding actuals to the last drop-off if earlier drop-offs are missing actuals
        const dropStops =
          (shipmentDetails?.shipmentStops || []).filter(
            (s) => (s.stopType || "").toUpperCase() === "DROP_OFF"
          ) || [];
        const currentSeq = stop.stopSequence ?? 0;
        const maxSeq = Math.max(
          ...dropStops.map((s) => s.stopSequence ?? 0),
          0
        );
        const isAddingDropActual = !!stop.actualGateOut;
        if (isAddingDropActual && currentSeq >= maxSeq) {
          const missingPrior = dropStops.filter(
            (s) =>
              (s.stopSequence ?? 0) < currentSeq && !s.actualGateOut
          );
          if (missingPrior.length > 0) {
            notify.error({
              title: "Add earlier drop-off actuals first",
              message:
                "Please enter actuals for the previous drop-off stops before completing the final drop-off.",
            });
            return;
          }
        }
      }

      const payload = {
        shipmentStops: [
          {
            id: stop.id,
            stopNumber: stop.stopNumber,
            addressLine1: stop.addressLine1,
            addressLine2: stop.addressLine2,
            city: stop.city,
            state: stop.state,
            zipCode: stop.zipCode,
            locationERPIdentifier: stop.locationERPIdentifier,
            appointmentStart: stop.appointmentStart,
            appointmentEnd: stop.appointmentEnd,
            stopReasonCode: stop.stopReasonCode,
            actualGateIn: stop.actualGateIn,
            actualGateOut: stop.actualGateOut,
          },
        ],
      };

      // Mirror modal logic: set shipment status when actuals change here too.
      const pm = (shipmentDetails?.paymentMethod || "").toLowerCase();
      const originalStops = shipmentDetails?.shipmentStops || [];
      const originalStop = originalStops.find((s) => s.id === stop.id);
      const stopType = (stop.stopType || originalStop?.stopType || "").toUpperCase();

      const updatedStopsForStatus = originalStops.map((s) =>
        s.id === stop.id
          ? {
              ...s,
              actualGateIn: stop.actualGateIn,
              actualGateOut: stop.actualGateOut,
            }
          : s
      );

      const isPickupStop = (stop.stopType || "").toUpperCase() === "PICKUP";
      const originalPickupHadActuals =
        isPickupStop &&
        originalStop?.actualGateIn &&
        originalStop?.actualGateOut;
      const pickupActualCleared =
        isPickupStop &&
        originalPickupHadActuals &&
        (!stop.actualGateIn || !stop.actualGateOut);
      const dropoffHasActual = updatedStopsForStatus.some(
        (s) =>
          (s.stopType || "").toUpperCase() === "DROP_OFF" && s.actualGateOut
      );

      if (pickupActualCleared && dropoffHasActual) {
        notify.error({
          title: "Cannot remove pickup actuals",
          message: "Clear dropoff actuals before removing pickup actuals.",
        });
        return;
      }

      const dropoffs = updatedStopsForStatus.filter(
        (s) => (s.stopType || "").toUpperCase() === "DROP_OFF"
      );
      const lastDropoff = dropoffs.reduce((acc, s) => {
        if (!acc) return s;
        const aSeq = acc.stopSequence ?? 0;
        const sSeq = s.stopSequence ?? 0;
        return sSeq > aSeq ? s : acc;
      }, null);

      const prevDropoffs = originalStops.filter(
        (s) => (s.stopType || "").toUpperCase() === "DROP_OFF"
      );
      const prevLastDropoff = prevDropoffs.reduce((acc, s) => {
        if (!acc) return s;
        const aSeq = acc.stopSequence ?? 0;
        const sSeq = s.stopSequence ?? 0;
        return sSeq > aSeq ? s : acc;
      }, null);

      const hasLastDropActual = !!(lastDropoff && lastDropoff.actualGateOut);
      const wasLastDropActual = !!(
        prevLastDropoff && prevLastDropoff.actualGateOut
      );

      const pickupHasActual = updatedStopsForStatus.some(
        (s) =>
          (s.stopType || "").toUpperCase() === "PICKUP" &&
          s.actualGateIn &&
          s.actualGateOut
      );
      const wasPickupActual = originalStops.some(
        (s) =>
          (s.stopType || "").toUpperCase() === "PICKUP" &&
          s.actualGateIn &&
          s.actualGateOut
      );

      if (hasLastDropActual) {
        payload.status = "Completed";
      } else if (pickupHasActual) {
        payload.status = pm === "collect" ? "Completed" : "Active";
      } else if (wasLastDropActual) {
        payload.status = "Active";
      } else if (wasPickupActual) {
        payload.status = "Accepted";
      }

      const nextStatus = payload.status || shipmentDetails?.status;

      await axios.put(
        `${process.env.REACT_APP_API_BASE_URL}/api/shipments/${shipmentDetails.shipmentNumber}`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Office-Code": officeCode,
            "Content-Type": "application/json",
          },
        }
      );

      if (nextStatus === "Completed") {
        const normalizeOrderNumbers = (value) =>
          (typeof value === "string" ? value : "")
            .split(",")
            .map((s) => s.trim())
            .filter(Boolean);

        const orderNumbers = normalizeOrderNumbers(
          shipmentDetails?.salesOrderNumber
        );

        if (orderNumbers.length > 0) {
          const putOrderStatus = async (orderNumber) =>
            axios.put(
              `${process.env.REACT_APP_API_BASE_URL}/api/orders/order-number/${orderNumber}/update`,
              { status: "Completed" },
              {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${token}`,
                  "Office-Code": officeCode,
                },
              }
            );

          await Promise.allSettled(orderNumbers.map(putOrderStatus));
        }
      }

  
    const originalStops2 = shipmentDetails?.shipmentStops || [];
    const originalStop2 = originalStops2.find((s) => s.id === stopId);

    const stopTypeUpper = (stop.stopType || originalStop2?.stopType || "").toUpperCase();

    // IMPORTANT: only fallback to original if the user did NOT edit the field.
    // If user edited it (even to cleared), use the edited value (normalized to null).
    const effectiveActualGateIn = hasProp(stop, "actualGateIn")
      ? toNullIfCleared(stop.actualGateIn)
      : toNullIfCleared(originalStop2?.actualGateIn);

    const effectiveActualGateOut = hasProp(stop, "actualGateOut")
      ? toNullIfCleared(stop.actualGateOut)
      : toNullIfCleared(originalStop2?.actualGateOut);

    const effectiveApptStart = hasProp(stop, "appointmentStart")
      ? toNullIfCleared(stop.appointmentStart)
      : toNullIfCleared(originalStop2?.appointmentStart);

    const effectiveApptEnd = hasProp(stop, "appointmentEnd")
      ? toNullIfCleared(stop.appointmentEnd)
      : toNullIfCleared(originalStop2?.appointmentEnd);


    const shouldSyncCharges = pm !== "collect";

    if (shouldSyncCharges) {
      console.log("DELETEING ACTUALS ", effectiveActualGateIn);
      try {
        await estimatedChargesApi.calculateStopEstimatedCharges({
          token,
          officeCode,
          shipmentNumber: shipmentDetails.shipmentNumber,
          stopId: stopId,                 // use the function arg (safe)
          stopType: stopTypeUpper,
          actualGateIn: effectiveActualGateIn,     // can be null
          actualGateOut: effectiveActualGateOut,   // can be null
          appointmentStartTime: effectiveApptStart, // can be null
          appointmentEndTime: effectiveApptEnd,     // can be null
        });
      } catch (err) {
        console.error("Failed to sync estimated charges:", err);
      }
    }

      notify.success({
        title: "Stop Details Updated",
        message: "Changes saved successfully.",
      });

      await fetchShipmentDetails();

      setEditedStops((prev) => {
        const updated = { ...prev };
        delete updated[stopId];
        return updated;
      });
      setIsEditMode(false);
    } catch (err) {
      console.error("❌ Error saving stop updates:", err);
      notify.error({
        title: "Save Failed",
        message: "Unable to save changes. Please try again.",
      });
    } finally {
      setIsSavingStopChanges(false);
    }
  };

  const handleRevertChargeChanges = async () => {
    setEditedCharges({});
    // Refetch shipment details to restore original values
    await fetchShipmentDetails();
};

    const handleSaveChargeChanges = async () => {
        setIsSavingChargeChanges(true);
        try {
            const token = Cookies.get("authToken");
            const officeCode = shipmentDetails?.officeCode;

            // Check if there are any changes before proceeding (including deletions)
            const hasAnyChanges = Object.values(editedCharges).some(charge => charge?.hasChanges || charge?.deleted);
            if (!hasAnyChanges) return;

            // Get all charges, using edited values where available, otherwise original values
            // Filter out deleted charges
            const chargesToSave = (shipmentDetails?.charges || []).map((charge, index) => {
                const editedCharge = editedCharges[index];

                // Skip deleted charges
                if (editedCharge?.deleted) {
                    return null;
                }
                
                // If this charge has been edited, use edited values; otherwise use original
                if (editedCharge?.hasChanges) {
                    return {
                        ...(charge?.id && { id: charge.id }),
                        code: editedCharge.code,
                        chargeName: editedCharge.chargeName,
                        amount: editedCharge.amount,
                        currency: editedCharge.currency || shipmentDetails.currency,
                        chargeApprovalStatus: editedCharge.chargeApprovalStatus,
                        invoiceNumber: editedCharge.invoiceNumber,
                        version: charge.version,
                        type: 'COST' //mchang: defaulting chargeType to 'COST'
                    };
                } else {
                  // Use original charge values
                  return {
                    ...(charge?.id && { id: charge.id }),
                    code: charge.code,
                    chargeName: charge.chargeName,
                    amount: charge.amount,
                    currency: charge.currency || shipmentDetails.currency,
                    chargeApprovalStatus: charge.chargeApprovalStatus,
                    invoiceNumber: charge.invoiceNumber,
                    version: charge.version,
                    type: 'COST' //mchang: defaulting chargeType to 'COST'
                  };
                }
            }).filter(Boolean); // Remove null entries (deleted charges)

            if (chargesToSave.length === 0) return;

            // Transform charges to match the expected format
            const shipmentCharges = chargesToSave.map((charge) => {
                let chargeName = charge.chargeName;
                if (charge.chargeName === 'BASE') {
                    chargeName = 'Base Charge';
                } else if (charge.chargeName === 'FSC') {
                    chargeName = 'Fuel Surcharge';
                }
                
                return {
                    shipment: { id: shipmentDetails.id },
                    amount: charge.amount,
                    currency: charge.currency || shipmentDetails.currency,
                    code: charge.code,
                    chargeName: chargeName,
                    chargeApprovalStatus: charge.chargeApprovalStatus,
                    invoiceNumber: charge.invoiceNumber,
                    type: charge.type,
                    ...(charge.id && { id: charge.id }),
                    ...(charge.version && { version: charge.version }),
                };
            });

            await axios.put(
                `${process.env.REACT_APP_API_BASE_URL}/api/shipment-charges-update/shipmentNumber/${shipmentDetails.shipmentNumber}/REORDER_STOPS_PARTIAL_RESET`,
                {
                    shipment: {},
                    shipmentCharges,
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                        "Office-Code": officeCode,
                    },
                }
            );

            notify.success({
                title: "Charge Details Updated",
                message: "Changes saved successfully.",
            });

            await fetchShipmentDetails();

            // Clear all edited charges after successful save
            setEditedCharges({});
        } catch (err) {
            console.error("❌ Error saving charge updates:", err);
            notify.error({
                title: "Save Failed",
                message: "Unable to save changes. Please try again.",
            });
        } finally {
            setIsSavingChargeChanges(false);
        }
    };



  return (
    <div className="w-full h-full min-h-0 flex flex-col transition-opacity duration-500 bg-gray-50">
      {/* Sticky Header */}
      <div
        ref={headerRef}
        className="sticky top-0 z-10 bg-white shadow-md w-full"
      >
        <StickyHeader
          leftLabel={activeSection}
          infoData={
            isEditable
              ? {
                  ...infoData,
                  Status: { ...infoData.Status, value: displayStatus },
                }
              : formatShipmentInfoDataForDisplay({
                  ...infoData,
                  Status: { ...infoData.Status, value: displayStatus },
                })
          }
          mode={null}
          onInfoChange={isEditable ? handleInfoChange : () => {}}
          templates={[]}
          onSelectTemplate={(t) => console.log("Selected Template:", t)}
          buttons={buttons}
          saveTemplateConfig={saveTemplateConfig}
          showStatusBlink={showStatusBlink}
        />
        {/* The permission fetch failing hides every action button, which otherwise looks
            like the shipment simply has no actions. Say so, and offer a retry. */}
        {permError && (
          <div
            role="alert"
            className="flex items-center justify-between gap-2 border-t border-amber-200 bg-amber-50 px-fluid-2 py-2 text-fluid-sm text-amber-800 dark:border-amber-700 dark:bg-acs-dark-surface dark:text-amber-300"
          >
            <span className="flex items-center gap-2">
              <AlertTriangle className="w-4 h-4 shrink-0 text-amber-600 dark:text-amber-400" />
              Couldn't load the actions available for this shipment, so the action
              buttons are hidden. The details below are unaffected.
            </span>
            <button
              type="button"
              onClick={() => setPermRetryToken((t) => t + 1)}
              disabled={permLoading}
              className="inline-flex items-center gap-1 shrink-0 rounded-md border border-amber-300 px-2 py-1 font-medium disabled:opacity-60 hover:bg-amber-100/80 dark:border-amber-700 dark:hover:bg-amber-900/30"
            >
              {permLoading ? (
                <Loader2 className="w-3.5 h-3.5 animate-spin" />
              ) : (
                <RefreshCcw className="w-3.5 h-3.5" />
              )}
              {permLoading ? "Retrying..." : "Retry"}
            </button>
          </div>
        )}
      </div>

      <ScrollbarWrapper
        ref={scrollContainerRef}
        className="flex-1 min-h-0 overflow-y-auto
            bg-white dark:bg-acs-dark-surface 
            w-full p-fluid-1 
            scroll-container overscroll-contain 
            text-gray-800 dark:text-acs-dark-text"
      >
        <div className="p-fluid-2">
          {/* === Shipment Info Details (Static Section) === */}
          <div className="flex items-center justify-between mb-fluid-2">
            <h3
              ref={setSectionRef("Shipment Information")}
              className="text-fluid-lg font-semibold"
            >
              Shipment Information
            </h3>
            <div className="flex items-center gap-fluid-1">
              {!isCarrier && isShipper && (
                  <button
                      onClick={openActivityPanel}
                      disabled={isCarrier}
                      className={`inline-flex items-center gap-2 rounded-md bg-acs-primary-navy px-3 py-1.5 text-sm font-medium text-white shadow-sm transition hover:bg-acs-primary-blue focus:outline-none focus:ring-2 focus:ring-acs-accent focus:ring-offset-2${isCarrier ? " opacity-50 cursor-not-allowed" : ""}`}
                  >
                    <Activity size={16}/>
                    Activity
                  </button>
              )}
              <button
                onClick={handleDownloadShipmentPdf}
                className="inline-flex items-center gap-2 rounded-md border border-gray-300 bg-white px-3 py-1.5 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
              >
                <FileText size={16} />
                Print
              </button>
            </div>
          </div>

          <div
            className="mb-fluid-3 rounded-md overflow-hidden
                border border-gray-300 dark:border-acs-dark-border 
                bg-white dark:bg-acs-dark-surface"
          >
            {/* Header Bar */}
            <div
              className="
              bg-[#1e2a74] dark:bg-blue-900/40 
              text-white dark:acs-dark-text
              text-fluid-base font-medium 
              px-fluid-2 py-fluid-1.5
            "
            >
              Core Shipment Details
            </div>

            {/* Content Grid */}
            <div
              className="grid grid-cols-6 gap-x-fluid-2 gap-y-fluid-3
                        p-fluid-3 
                        bg-[#F9FAFE] dark:bg-acs-dark-surface
                        text-gray-800 dark:text-acs-dark-text"
            >
              <DisplayDetail
                label="Shipment Number"
                value={shipmentDetails.shipmentNumber}
              />
              <DisplayDetail
                label="Carrier Name"
                value={shipmentDetails.carrierName}
              />
              <DisplayDetail
                label="Carrier Code"
                value={shipmentDetails.carrierOfficeCode?.partyOfficeCode}
              />
              <DisplayDetail
                label="INCO term"
                value={shipmentDetails.incoterm}
              />
              <DisplayDetail
                label="Transit Miles"
                value={shipmentDetails.totalMiles}
              />
              <DisplayDetail
                label="Transit Time"
                value={formatTransitTime(shipmentDetails.totalSeconds)}
              />
              <DisplayDetail
                label="Release Number"
                value={shipmentDetails.releaseNumber}
              />
              <DisplayDetail
                label="Service Type"
                value={shipmentDetails.serviceType}
              />
              <DisplayDetail
                label="Total Charge"
                value={
                (shipmentDetails.paymentMethod === "COLLECT" &&
                (!shipmentDetails.totalCharge || Number(shipmentDetails.totalCharge) === 0))
                  ? ""
                  : formatMoney(shipmentDetails.totalCharge, shipmentDetails.currency)
                }
              />
              <DisplayDetail
                label="Payment Type"
                value={shipmentDetails.paymentMethod}
              />
              <DisplayDetail
                label="Is Invoiced"
                value={shipmentDetails.isInvoiced ? "Yes" : "No"}
              />
              <DisplayDetail
                label="Is Appointment Created"
                value={shipmentDetails.isAppointmentCreated ? "Yes" : "No"}
              />
              <DisplayDetail label="Equipment Type" value="53 Feet Dry Van" />
              <DisplayDetail
                label="Planned Pickup Date"
                value={(() => {
                  const sorted = [
                    ...(shipmentDetails.shipmentStops || []),
                  ].sort(
                    (a, b) => (a.stopSequence ?? 0) - (b.stopSequence ?? 0)
                  );

                  const date = sorted[0]?.scheduledGateOut;
                  return date
                    ? new Date(date).toLocaleDateString("en-US", {
                        year: "numeric",
                        month: "2-digit",
                        day: "2-digit",
                      })
                    : "—";
                })()}
              />
              <DisplayDetail
                label="Planned Delivery Date"
                value={(() => {
                  const sorted = [
                    ...(shipmentDetails.shipmentStops || []),
                  ].sort(
                    (a, b) => (a.stopSequence ?? 0) - (b.stopSequence ?? 0)
                  );

                  const date = sorted[sorted.length - 1]?.scheduledGateIn;
                  return date
                    ? new Date(date).toLocaleDateString("en-US", {
                        year: "numeric",
                        month: "2-digit",
                        day: "2-digit",
                      })
                    : "—";
                })()}
              />
                <DisplayDetail
                label="Invoice Number"
                value={shipmentDetails.invoiceNumber || "--"}
              />
              <DisplayDetail
  label="Invoice Status"
  value={
    shipmentDetails.invoiceNumber
      ? shipmentDetails.invoiceStatus || "--"
      : "Not Invoiced"
  }
/>
   <DisplayDetail
  label="Invoice Date"
  value={
    
    shipmentDetails.invoiceDate
      ? formatDateOnly(shipmentDetails.invoiceDate)
      : "--"
  }
/>
            </div>
          </div>

          <h3
            ref={setSectionRef("Shipment Summary")}
            className="text-fluid-lg font-semibold mb-fluid-2"
          >
            Shipment Summary
          </h3>

          <ExpandableHeader
            headerLabel="Summary Details"
            headerType="primary"
            initiallyExpanded={false}
            icon={FileText}
          >
            <div
              className="grid grid-cols-6 gap-x-fluid-2 gap-y-fluid-3
                        p-fluid-3 
                        bg-[#F9FAFE] dark:bg-acs-dark-surface
                        text-gray-800 dark:text-acs-dark-text"
            >
              <DisplayDetail
                label="Shipper Name"
                value={shipmentDetails.shipperName}
              />
              <DisplayDetail
                label="Shipper Office Code"
                value={shipmentDetails.shipperOfficeCode?.partyOfficeCode}
              />
              <DisplayDetail
                label="Receiver Name"
                value={shipmentDetails.receiverName}
              />
              <DisplayDetail
                label="Receiver Office Code"
                value={shipmentDetails.receiverOfficeCode?.partyOfficeCode}
              />
              <DisplayDetail
                label="Created Date"
                value={formatDisplayDate(shipmentDetails.createdDate)}
              />
              <DisplayDetail
                label="Created By"
                value={shipmentDetails.createdBy}
              />
              <DisplayDetail
                label="Updated Date"
                value={formatDisplayDate(shipmentDetails.updatedDate)}
              />
              <DisplayDetail
                label="Updated By"
                value={shipmentDetails.updatedBy}
              />
              <DisplayDetail
                label="UN Hazmat Number"
                value={shipmentDetails.unNumber}
              />
              <DisplayDetail
                label="Temperature Controlled"
                value={shipmentDetails.temperatureControlled ? "Yes" : "No"}
              />
              <DisplayDetail
                label="Order Value"
                value={shipmentDetails.orderValue}
              />
              <DisplayDetail
                label="Currency"
                value={shipmentDetails.currency || "USD"}
              />
              <DisplayDetail
                label="Total Weight"
                value={shipmentDetails.totalWeight}
              />
              <DisplayDetail
                label="Weight Unit"
                value={shipmentDetails.weightUnit}
              />
              <DisplayDetail
                label="Total Volume"
                value={shipmentDetails.totalVolume}
              />
              <DisplayDetail
                label="Volume Unit"
                value={shipmentDetails.volumeUnit}
              />
              <DisplayDetail
                  label="PRO Number"
                  value={shipmentDetails.proNumber || "--"}
                  icon={canEditProNumber ? <Edit size={16} className="text-blue-500 cursor-pointer" /> : null}
                  onClick={canEditProNumber ? () => {
                    setProModalMode("edit");
                    setShowProModal(true);
                  } : undefined}
              />
            
            </div>
          </ExpandableHeader>

          <h3
            ref={setSectionRef("Stops")}
            className="text-fluid-lg font-semibold mb-fluid-2"
          >
            Stops
          </h3>

          {(shipmentDetails.shipmentStops || []).map((stop, index) => {
            const stopKey = stop.id || stop.stopNumber || index;
            const stopType = stop.stopType || "—";
            const stopTypeUpper = stopType.toString().toUpperCase();
            const isCarrierDropoff =
              isCarrierOrg &&
              (stopTypeUpper === "DROP_OFF" || stopTypeUpper === "DROP OFF");
            const baseEditableFields = [
              "Address Line 1",
              "Address Line 2",
              "City",
              "State",
              "Zip Code",
              "Site",
              "Appointment Start",
              "Appointment End",
              "Stop Reason",
            ];

            const shipperExtraFields = [
              "Actual Gate-In",
              "Actual Gate-Out",
              "Sales Order Numbers",
              "PO Numbers",
              "Total Pallets",
              "Total Weight",
              "Total Weight Unit",
              "Total Volume",
              "Total Volume Unit"
            ];

            const editableFieldsForStop = isCarrierDropoff
              ? ["Appointment Start", "Appointment End", "Actual Gate-In", "Actual Gate-Out"]
              : [
                  ...baseEditableFields,
                  ...(isShipperOrg ? shipperExtraFields : []),
                ];

            const stopEntries = [
              { label: "Location Name", value: stop.stopName || "—" },
              { label: "Warehouse/Terminal", value: stop.warehouseName || "—" },
              { label: "Site", value: stop.locationERPIdentifier || "—" },
              { label: "Stop Type", value: stopType },
              {
                label: "Stop Reason",
                value: stop.stopReasonName || stop.stopReasonCode || "—",
              },
              { label: "Address Line 1", value: stop.addressLine1 || "—" },
              { label: "Address Line 2", value: stop.addressLine2 || "—" },
              { label: "City", value: stop.city || "—" },
              { label: "State", value: stop.state || "—" },
              { label: "Zip Code", value: stop.zipCode || "—" },
              { label: "Country", value: stop.country || "—" },
              {
                label: "Planned Gate-In",
                value: stop.scheduledGateIn
                  ? new Date(stop.scheduledGateIn).toLocaleString("en-US", {
                      year: "numeric",
                      month: "2-digit",
                      day: "2-digit",
                      // hour: "2-digit",
                      // minute: "2-digit",
                      // hour12: true,
                    })
                  : "—",
              },
              {
                label: "Planned Gate-Out",
                value: stop.scheduledGateOut
                  ? new Date(stop.scheduledGateOut).toLocaleString("en-US", {
                      year: "numeric",
                      month: "2-digit",
                      day: "2-digit",
                      // hour: "2-digit",
                      // minute: "2-digit",
                      // hour12: true,
                    })
                  : "—",
              },
              {
                label: "Predicted Gate-In",
                value: formatDateOnly(stop.predictedGateIn) || "—",
              },
              {
                label: "Predicted Gate-Out",
                value: formatDateOnly(stop.predictedGateOut) || "—",
              },
              {
                label: "Appointment Start",
                value: stop.appointmentStart
                  ? new Date(stop.appointmentStart).toLocaleString("en-US", {
                      year: "numeric",
                      month: "2-digit",
                      day: "2-digit",
                      hour: "2-digit",
                      minute: "2-digit",
                      hour12: true,
                    })
                  : "—",
              },
              // {
              //   label: "Appointment End",
              //   value: stop.appointmentStart
              //     ? (() => {
              //         const start = new Date(stop.appointmentStart);
              //         const end = new Date(start.getTime() + 30 * 60000); // +30 mins
              //         return end.toLocaleString("en-US", {
              //           year: "numeric",
              //           month: "2-digit",
              //           day: "2-digit",
              //           hour: "2-digit",
              //           minute: "2-digit",
              //           hour12: true,
              //         });
              //       })()
              //     : "—",
              // },

              {
                label: "Actual Gate-In",
                value: stop.actualGateIn
                  ? new Date(stop.actualGateIn).toLocaleString("en-US", {
                      year: "numeric",
                      month: "2-digit",
                      day: "2-digit",
                      hour: "2-digit",
                      minute: "2-digit",
                      second: "2-digit",
                      hour12: true,
                    })
                  : "—",
              },
              {
                label: "Actual Gate-Out",
                value: stop.actualGateOut
                  ? new Date(stop.actualGateOut).toLocaleString("en-US", {
                      year: "numeric",
                      month: "2-digit",
                      day: "2-digit",
                      hour: "2-digit",
                      minute: "2-digit",
                      second: "2-digit",
                      hour12: true,
                    })
                  : "—",
              },
              ...(stopType === "PICKUP"
                ? [
                    {
                      label: "Ready For Pickup",
                      value: stop.readyForPickupDateTime
                        ? new Date(stop.readyForPickupDateTime).toLocaleString(
                            "en-US",
                            {
                              year: "numeric",
                              month: "2-digit",
                              day: "2-digit",
                              hour: "2-digit",
                              minute: "2-digit",
                              hour12: true,
                            },
                          )
                        : "—",
                    },
                  ]
                : []),
            ];              


            return (
              <ExpandableHeader
                key={stopKey}
                headerSection={`Stop ${index + 1}`}
                headerLabel={
                  <div className="flex items-center gap-3 flex-wrap">
                    <span>{`${stopType} — ${stop.stopName || "Unknown"}`}</span>
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        openLocationTabForStop(stop, index);
                      }}
                      className="text-xs px-2 py-1 rounded-md border border-gray-300 text-gray-300 hover:border-blue-500 hover:text-blue-600 transition"
                    >
                      View Location
                    </button>
                  </div>
                }
                icon={MapPin}
                headerType="primary"
                isExpanded={expandedStops[stopKey] ?? false}
                onToggle={() =>
                  setExpandedStops((prev) => ({
                    ...prev,
                    [stopKey]: !(prev[stopKey] ?? false),
                  }))
                }
                rightSection={
                  isShipperOrg || isCarrierDropoff ? (
                    <div className="flex items-center space-x-2">
                      <button
                        onClick={() => handleEditStop(stop, stopKey)}
                        className="p-1.5 rounded-full text-acs-dark-text dark:text-acs-dark-text hover:bg-acs-dark-hover dark:hover:bg-acs-dark-hover transition"
                        title="Edit stop details"
                      >
                        <Edit size={16} />
                      </button>
                    </div>
                  ) : null
                }
              >
                <div
                  className="grid grid-cols-5 gap-x-fluid-2 gap-y-fluid-3
                   p-fluid-3 
                   bg-[#F9FAFE] dark:bg-acs-dark-surface
                   text-gray-800 dark:text-acs-dark-text"
                >
                  {stopEntries.map((entry, idx) => {
                    const field = fieldMap(entry.label);
                    const isEditableField = editableFieldsForStop.includes(
                      entry.label
                    );

                    const isEditing =
                      isEditMode && isEditableField && editedStops[stop.id];
                    const isDropoffWithoutPickupActual =
                      stop.stopType === "DROP_OFF" && !pickupActualGateOut;

                    return (
                      <div
                        key={idx}
                        className="flex flex-col min-w-[clamp(8rem,12vw,10rem)]"
                      >
                        <span className="text-dense-xs text-gray-500">
                          {entry.label}
                        </span>

                        <div
                          className={`relative flex items-center w-full 
                            px-fluid-2 py-fluid-1.5 mt-fluid-0.25
                            rounded-md border text-fluid-sm font-inter
                            ${
                              isEditing
                                ? "border-gray-500 dark:border-gray-400"
                                : "border-gray-300 dark:border-acs-dark-border"
                            }
                            bg-[#FAFAFB] dark:bg-acs-dark-surface 
                            text-gray-700 dark:text-acs-dark-text
                            transition-none`}
                        >
                          {isEditing ? (
                            ["appointmentStart", "appointmentEnd", "actualGateIn", "actualGateOut"].includes(
                              field
                            ) ? (
                              ["appointmentStart", "appointmentEnd"].includes(field) && (index === 0 || (stop.stopType === "DROP_OFF" && status === "Completed")) ? (
                                // Disable Appointment Start/End for first stop (Pickup)
                                <input
                                  type="datetime-local"
                                  value={editedStops[stop.id][field] || ""}
                                  disabled
                                  className="w-full bg-transparent text-sm text-gray-500 cursor-not-allowed pr-7"
                                />
                              ) : (
                                <>
                                  <input
                                    ref={(el) => {
                                      datePickersRef.current = {
                                        ...datePickersRef.current,
                                        [`${stop.id}-${field}`]: el,
                                      };
                                    }}
                                    type="datetime-local"
                                    step="1"
                                    value={
                                      editedStops[stop.id][field]
                                        ? toLocalInputValue(
                                            editedStops[stop.id][field]
                                          )
                                        : ""
                                    }
                                    onChange={(e) =>
                                      handleStopFieldChange(
                                        stop.id,
                                        field,
                                        fromLocalInputValue(e.target.value)
                                      )
                                    }
                                    min={
                                      field === "actualGateIn"
                                        ? stop.stopType === "DROP_OFF" &&
                                          pickupActualGateOutLocal
                                          ? pickupActualGateOutLocal
                                          : undefined
                                        : field === "actualGateOut"
                                        ? editedStops[stop.id]?.actualGateIn
                                          ? toLocalInputValue(
                                              editedStops[stop.id].actualGateIn
                                            )
                                          : stop.stopType === "DROP_OFF" &&
                                            pickupActualGateOutLocal
                                          ? pickupActualGateOutLocal
                                          : undefined
                                        : undefined
                                    }
                                    max={
                                      ["actualGateIn", "actualGateOut"].includes(
                                        field
                                      )
                                        ? futureLimitLocalInput
                                        : undefined
                                    }
                                    disabled={
                                      ["actualGateIn", "actualGateOut"].includes(
                                        field
                                      ) && isDropoffWithoutPickupActual
                                    }
                                    title={
                                      ["actualGateIn", "actualGateOut"].includes(
                                        field
                                      ) && isDropoffWithoutPickupActual
                                        ? "Add pickup actuals before entering dropoff actuals."
                                        : undefined
                                    }
                                    className={`w-full bg-transparent focus:outline-none text-sm pr-7 ${
                                      ["actualGateIn", "actualGateOut"].includes(
                                        field
                                      ) && isDropoffWithoutPickupActual
                                        ? "text-gray-400 cursor-not-allowed"
                                        : ""
                                    }`}
                                  />

                                  <button
                                    type="button"
                                    onClick={() =>
                                      !(
                                        ["actualGateIn", "actualGateOut"].includes(
                                          field
                                        ) && isDropoffWithoutPickupActual
                                      ) &&
                                      datePickersRef.current[
                                        `${stop.id}-${field}`
                                      ]?.showPicker()
                                    }
                                    className="absolute right-2 top-1/2 -translate-y-1/2
                                text-gray-500 dark:text-acs-dark-subtext 
                                hover:text-blue-600 dark:hover:text-[#3B5CCC]
                                transition-none"
                                  >
                                    <Calendar size={16} />
                                  </button>
                                </>
                              )
                            ) : field === "stopReasonCode" ? (
                              <div className="relative w-full">
                                <button
                                  type="button"
                                  onClick={() =>
                                    setOpenStopReasonDropdown((prev) =>
                                      prev === stop.id ? null : stop.id
                                    )
                                  }
                                  className="w-full text-left bg-transparent focus:outline-none text-sm flex justify-between items-center"
                                >
                                  <span>
                                    {editedStops[stop.id][field]
                                      ? stopReasonOptions.find(
                                          (opt) =>
                                            opt.code === editedStops[stop.id][field]
                                        )?.description || "Select a stop reason"
                                      : "Select a stop reason"}
                                  </span>
                                  <svg
                                    className={`ml-2 w-4 h-4 transform transition-transform duration-200 ${
                                      openStopReasonDropdown === stop.id ? "rotate-180" : ""
                                    }`}
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                  >
                                    <path
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      strokeWidth="2"
                                      d="M19 9l-7 7-7-7"
                                    />
                                  </svg>
                                </button>

                                {openStopReasonDropdown === stop.id && (
                                  <div className="absolute left-0 right-0 mt-1 max-h-60 overflow-y-auto bg-white border border-gray-300 rounded shadow-lg z-10 animate-in fade-in-0 zoom-in-95">
                                    {stopReasonOptions.map((opt) => (
                                      <button
                                        key={opt.code || opt.id}
                                        onClick={() =>
                                          handleStopReasonChange(stop.id, opt.code)
                                        }
                                        className="w-full text-left px-3 py-2 hover:bg-gray-100 text-sm"
                                      >
                                        {opt.description === "Load"
                                          ? "Live Load"
                                          : opt.description}
                                      </button>
                                    ))}
                                  </div>
                                )}
                              </div>
                            ) : (
                              //  Editable normal text fields
                              <input
                                type="text"
                                className="w-full bg-transparent focus:outline-none text-sm"
                                value={editedStops[stop.id][field] || ""}
                                onChange={(e) =>
                                  handleStopFieldChange(
                                    stop.id,
                                    field,
                                    e.target.value
                                  )
                                }
                              />
                            )
                          ) : (
                            <span>{entry.value ?? "—"}</span>
                          )}
                        </div>
                      </div>
                    );
                  })}

                  {editedStops[stop.id]?.hasChanges && (
                    <div className="flex items-center justify-end space-x-2 pt-3 mt-4 col-span-5">
                      <button
                        onClick={() => handleSaveStopChanges(stop.id)}
                        disabled={isSavingStopChanges}
                        className="flex items-center space-x-1 px-3 py-1 bg-green-600 text-white rounded
                 hover:bg-green-700 disabled:opacity-50 disabled:cursor-not-allowed text-sm"
                      >
                        <span>
                          {isSavingStopChanges ? "Saving..." : "Save Changes"}
                        </span>
                      </button>
                      <button
                        onClick={() => handleRevertStopChanges(stop.id)}
                        disabled={isSavingStopChanges}
                        className="flex items-center space-x-1 px-3 py-1 bg-gray-500 text-white rounded
                 hover:bg-gray-600 disabled:opacity-50 disabled:cursor-not-allowed text-sm"
                      >
                        <span>Revert</span>
                      </button>
                    </div>
                  )}
                </div>
                 <div className="ml-4 mr-2 mb-fluid-3">
                  <ExpandableHeader
                      headerLabel="Stop Order Summary"
                      icon={Package}
                      headerType="secondary"
                      initiallyExpanded={true}
                    >
                      <div
                        className="grid grid-cols-7 gap-x-fluid-2 gap-y-fluid-3
                                  p-fluid-3
                                  bg-[#F9FAFE] dark:bg-acs-dark-surface
                                  text-gray-800 dark:text-acs-dark-text"
                      >
                        <DisplayDetail
                          label="Sales Order Numbers"
                          value={stop.salesOrderNumbers || "—"}
                        />
                        <DisplayDetail
                          label="PO Numbers"
                          value={stop.poNumbers || "—"}
                        />
                        <DisplayDetail
                          label="Total Pallets"
                          value={stop.stopOrderTotalPallets ?? "—"}
                        />
                        <DisplayDetail
                          label="Total Weight"
                          value={stop.stopOrderTotalWeight ?? "—"}
                        />
                        <DisplayDetail
                          label="Weight Unit"
                          value={stop.stopOrderTotalWeightUnit || "—"}
                        />
                        <DisplayDetail
                          label="Total Volume"
                          value={stop.stopOrderTotalVolume ?? "—"}
                        />
                        <DisplayDetail
                          label="Volume Unit"
                          value={stop.stopOrderTotalVolumeUnit || "—"}
                        />
                      </div>
                    </ExpandableHeader>
                </div>

                {stop.stopType === "DROP_OFF" && (
                  <div className="ml-4 mr-2 mb-fluid-3">
                  <ExpandableHeader
                      headerLabel="Location Information"
                      icon={MapPin}
                      headerType="tertiary"
                      initiallyExpanded={true}
                    >
                      <div
                        className="grid grid-cols-3 gap-x-fluid-2 gap-y-fluid-3
                                  p-fluid-3
                                  bg-[#F9FAFE] dark:bg-acs-dark-surface
                                  text-gray-800 dark:text-acs-dark-text"
                      >
                        <DisplayDetail
                          label="Contact Person"
                          value={stop.contactName || "—"}
                        />
                        <DisplayDetail
                          label="Phone"
                          value={stop.contactPhone || "—"}
                        />
                        <DisplayDetail
                          label="Email"
                          value={linkifyEmails(stop.contactEmail) || "—"}
                        />
                        <DisplayDetail
                          label="Location Notes"
                          className="col-span-3"
                          value={stop.locationNotes || "—"}
                          multiline={true}
                          autoLink={true}
                        />
                      </div>


                    </ExpandableHeader>


                </div>)}
              </ExpandableHeader>
            );
          })}

          <h3
            ref={setSectionRef("Charges")}
            className="text-fluid-lg font-semibold mb-fluid-2"
          >
            Charges
          </h3>

          <ExpandableHeader
            headerLabel="Charge Details"
            icon={DollarSign}
            headerType="primary"
            initiallyExpanded={false}
            allowOverflow
            // rightSection={
            //     can("Add Accessorial") && (
            //         <button
            //             onClick={() => handleAddCharge()}
            //             className="p-1.5 rounded-full transition text-acs-dark-text dark:text-acs-dark-text hover:bg-acs-dark-hover dark:hover:bg-acs-dark-hover"
            //             title="Add Charge"
            //             aria-label="Add Charge"
            //         >
            //             <Plus size={16} />
            //         </button>
            //     )
            // }
          >
            {shipmentDetails.charges?.length ? (
              <div
                className="bg-[#F9FAFE] p-fluid-3 space-y-fluid-3 dark:bg-acs-dark-surface
                        text-gray-800 dark:text-acs-dark-text"
              >
                {shipmentDetails.charges.map((charge, idx) => {
                                    // Skip deleted charges
                                    if (editedCharges[idx]?.deleted) {
                                        return null;
                                    }
                                    
                                    const isAccessorial = charge.code !== 'BASE' && charge.code !== 'FSC';
                                    const isFSC = charge.code === 'FSC';
                                    const statusValue = charge.chargeApprovalStatus || "PREAPPROVED";
                                    const statusDisplay = statusValue === "PREAPPROVED"
                                      ? <span className="text-green-600 font-semibold">PRE-APPROVED</span>
                                      : statusValue;
                                    if (isAccessorial || isFSC ) {
                                        const hasPermission = can("Add Accessorial");
                                        const amountValue = charge.amount ?? "";
                                        const amountDisplay =
                                          charge.amount != null
                                            ? formatMoney(charge.amount, charge.currency)
                                            : "—";
                                        return (
                                            <div key={idx} className="relative">
                                                <div
                                                    className="grid grid-cols-6 gap-x-fluid-2 gap-y-fluid-3 text-gray-800"
                                                >
                                                    <div className="flex flex-col min-w-[clamp(8rem,12vw,10rem)]">
                                                      <span className="text-dense-xs text-gray-500">Charge Code</span>
                                                      <div className="relative flex items-center w-full 
  px-fluid-2 py-fluid-1.5 mt-fluid-0.25
  rounded-md border text-fluid-sm font-inter
  bg-[#FAFAFB] text-gray-700 border-gray-300">
  <select
    value={charge.code || ""}
    disabled={!hasPermission}
    onChange={(e) => handleChargeCodeChange(idx, e.target.value)}
    className="w-full bg-transparent focus:outline-none text-sm border-none disabled:cursor-not-allowed disabled:opacity-70 appearance-none pr-6"
  >
    <option value="">Select charge code</option>
    {charge.code && !chargeCodes.includes(charge.code) && (
    <option value={charge.code}>{charge.code}</option>
  )}
    {chargeCodes.map(code => (
      <option key={code} value={code}>{code}</option>
    ))}
  </select>
  <svg
    className="pointer-events-none absolute right-2 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-500"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
  >
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
  </svg>
</div>
                                                    </div>
                                                    <DisplayDetail 
                                                        label="Charge Name" 
                                                        value={charge.code === 'FSC' ? 'Fuel Surcharge' : charge.chargeName}
                                                        isEditable={hasPermission}
                                                        onChange={(value) => handleChargeChange(idx, 'chargeName', value)}
                                                    />
                                                   <div className="flex flex-col min-w-[clamp(8rem,12vw,10rem)]">
  <span className="text-dense-xs text-gray-500">Total Amount</span>

  <div className="relative flex items-center w-full 
      px-fluid-2 py-fluid-1.5 mt-fluid-0.25
      rounded-md border text-fluid-sm font-inter
      bg-[#FAFAFB] text-gray-700 border-gray-300"
  >
    {hasPermission ? (
      editingAmountIdx === idx ? (
        <>
          <span className="absolute left-fluid-2 text-gray-500">$</span>
          <input
            autoFocus
            type="number"
            step="0.01"
            className="w-full bg-transparent focus:outline-none text-sm pl-5"
            value={charge.amount ?? ""}
            onChange={(e) => handleChargeChange(idx, "amount", e.target.value)}
            onBlur={() => {
              const n = Number(charge.amount);
              handleChargeChange(
                idx,
                "amount",
                Number.isFinite(n) ? n.toFixed(2) : ""
              );
              setEditingAmountIdx(null);
            }}
          />
        </>
      ) : (
        <button
          type="button"
          onClick={() => setEditingAmountIdx(idx)}
          className="w-full text-left"
          title="Click to edit"
        >
          {formatMoney(charge.amount, charge.currency || shipmentDetails.currency) ?? "—"}
        </button>
      )
    ) : (
      <span>
        {formatMoney(charge.amount, charge.currency || shipmentDetails.currency) ?? "—"}
      </span>
    )}
  </div>
</div>

                                                    <DisplayDetail
                                                        label="Approval Status"
                                                        value={statusDisplay}
                                                    />
                                                    <DisplayDetail
                                                        label="Invoice Number"
                                                        value={charge.invoiceNumber || "—"}
                                                    />
                                                    <div className="relative flex items-center justify-center">
                                                        {hasPermission && charge.code !== 'BASE' && (
                                                            <button
                                                                type="button"
                                                                onClick={() => handleDeleteCharge(idx)}
                                                                className="p-1 text-red-600 hover:text-red-700 transition-colors self-center"
                                                                title="Delete charge"
                                                            >
                                                                <Trash size={16} />
                                                            </button>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        ); //testing change 
                                    }
                                    return (
                                        <div key={idx} className="relative">
                                            <div
                                                className="grid grid-cols-6 gap-x-fluid-2 gap-y-fluid-3 text-gray-800"
                                            >
                                                <DisplayDetail 
                                                    label="Charge Code" 
                                                    value={charge.code}
                                                    onChange={(value) => handleChargeChange(idx, 'code', value)}
                                                />
                                                <DisplayDetail 
                                                    label="Charge Name" 
                                                    value={charge.code === 'FSC' ? 'Fuel Surcharge' : charge.chargeName}
                                                    onChange={(value) => handleChargeChange(idx, 'chargeName', value)}
                                                />
                                                <DisplayDetail
                                                    label="Total Amount"
                                                   value={isEditable
                                                    ? (charge.amount || "")
                                                    : (shipmentDetails.paymentMethod === "COLLECT" &&
                                                    (!charge.amount || Number(charge.amount) === 0))
                                                    ? ""
                                                    : formatMoney(charge.amount, charge.currency)}
                                                />
                                            
                                                <DisplayDetail
                                                    label="Approval Status"
                                                    value={statusDisplay}
                                                />
                                                <DisplayDetail
                                                    label="Invoice Number"
                                                    value={charge.invoiceNumber || "—"}
                                                />
                                                <div className="relative flex items-center justify-center">
                                                    {can("Add Accessorial") && charge.code !== 'BASE' && charge.code !== 'FSC' && (
                                                        <button
                                                            type="button"
                                                            onClick={() => handleDeleteCharge(idx)}
                                                            className="p-1 text-red-600 hover:text-red-700 transition-colors self-center"
                                                            title="Delete charge"
                                                        >
                                                            <Trash size={16} />
                                                        </button>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                                {can("Add Accessorial") && (
  <div className="flex justify-end mt-3 mb-1">
    <button
      type="button"
      onClick={handleAddCharge}
      className="h-8 px-3 text-xs bg-[#1e2a74] text-white rounded hover:bg-[#2d3d99] transition-colors"      >
      + Add Charge
    </button>
  </div>
)}
                                {Object.values(editedCharges).some(charge => charge?.hasChanges || charge?.deleted) && (
                                    <div className="flex items-center justify-end space-x-2 pt-3 mt-4">
                                        <button
                                            onClick={handleSaveChargeChanges}
                                            disabled={isSavingChargeChanges}
                                            className="flex items-center space-x-1 px-3 py-1 bg-green-600 text-white rounded
                                         hover:bg-green-700 disabled:opacity-50 disabled:cursor-not-allowed text-sm"
                                        >
                                            <span>
                                                {isSavingChargeChanges ? "Saving..." : "Save All Changes"}
                                            </span>
                                        </button>
                                        <button
                                            onClick={handleRevertChargeChanges}
                                            disabled={isSavingChargeChanges}
                                            className="flex items-center space-x-1 px-3 py-1 bg-gray-500 text-white rounded
                                         hover:bg-gray-600 disabled:opacity-50 disabled:cursor-not-allowed text-sm"
                                        >
                                            <span>Revert All</span>
                                        </button>
                                    </div>
                                )}
              </div>
            ) : (
              <p
                className="text-gray-500 italic px-fluid-3 py-fluid-2 space-y-fluid-3 dark:bg-acs-dark-surface
                        text-gray-800 dark:text-acs-dark-text"
              >
                No charges available.
              </p>
            )}
          </ExpandableHeader>

          {isShipperOrg && (
            <ExpandableHeader
              headerLabel="Estimated Charges"
              icon={DollarSign}
              headerType="primary"
              initiallyExpanded={false}
            >
              {shipmentDetails.estimatedCharges?.length && isShipperOrg ? (
                <div
                  className="bg-[#F9FAFE] p-fluid-3  space-y-fluid-3 dark:bg-acs-dark-surface
                          text-gray-800 dark:text-acs-dark-text"
                >
                  {shipmentDetails.estimatedCharges.map((ec, idx) => (
                    <div
                      key={ec.id ?? idx}
                      className="grid grid-cols-4 gap-x-fluid-2 gap-y-fluid-3 text-gray-800"
                    >
                      <DisplayDetail label="Code" value={ec.code || "—"} />
                      <DisplayDetail
                        label="Charge Name"
                        value={ec.chargeName || "—"}
                      />
                      <DisplayDetail
                        label="Amount"
                        value={
                          ec.amount != null
                            ? formatMoney(ec.amount, ec.currency)
                            : "—"
                        }
                      />
                      <DisplayDetail
                        label="Currency"
                        value={ec.currency || shipmentDetails.currency || "USD"}
                      />
                    </div>
                  ))}

                  <div className="pt-2 border-t border-gray-300 text-right font-medium">
                    Total Estimated:&nbsp;
                    {(() => {
                      const sum = shipmentDetails.estimatedCharges.reduce(
                        (acc, c) => acc + (Number(c.amount) || 0),
                        0
                      );
                      return formatMoney(
                        sum,
                        shipmentDetails.estimatedCharges?.[0]?.currency
                      );
                    })()}
                  </div>
                </div>
              ) : (
                <p
                  className="text-gray-500 italic px-fluid-3 py-fluid-2 space-y-fluid-3 dark:bg-acs-dark-surface
                          text-gray-800 dark:text-acs-dark-text"
                >
                  No estimated charges yet.
                </p>
              )}
            </ExpandableHeader>
          )}

          <ShipmentItems
            items={shipmentDetails.items}
            setSectionRef={setSectionRef}
            PACKAGE_TYPE_MAP={PACKAGE_TYPE_MAP}
          />

          {/* === Party Section === */}
          <h3
            ref={setSectionRef("Party")}
            className="text-fluid-lg font-semibold mb-fluid-2"
          >
            Party
          </h3>

          <ExpandableHeader
            headerLabel="Party Details"
            icon={Users}
            headerType="secondary"
            initiallyExpanded={false}
          >
            <div
              className="grid grid-cols-5 gap-x-fluid-2 gap-y-fluid-3
                        p-fluid-3 
                        bg-[#F9FAFE] dark:bg-acs-dark-surface
                        text-gray-800 dark:text-acs-dark-text"
            >
              <DisplayDetail
                label="Bill To"
                value={
                  shipmentDetails.paymentMethod !== "COLLECT"
                    ? fallbackName(shipmentDetails.shipperOfficeCode?.name) ||
                      "—"
                    : fallbackName(shipmentDetails.receiverOfficeCode?.name) ||
                      "—"
                }
              />
              <DisplayDetail
                label="Pay To"
                value={shipmentDetails.carrierOfficeCode?.name || "—"}
              />
              <DisplayDetail
                label="Ship To"
                value={shipmentDetails.receiverOfficeCode?.name || "—"}
              />
            </div>
          </ExpandableHeader>

          {/* === References Section === */}
          <h3
            ref={setSectionRef("References")}
            className="text-fluid-lg font-semibold mb-fluid-2"
          >
            References
          </h3>

          <ExpandableHeader
            headerLabel="Reference Details"
            icon={ClipboardList}
            headerType="tertiary"
            initiallyExpanded={false}
          >
            <div
              className="grid grid-cols-5 gap-x-fluid-2 gap-y-fluid-3
                        p-fluid-3 
                        bg-[#F9FAFE] dark:bg-acs-dark-surface
                        text-gray-800 dark:text-acs-dark-text"
            >
              <DisplayDetail label="Sales Rep Identifier" value="—" />
              <DisplayDetail label="Transfer Number" value="—" />
              <DisplayDetail
                label="Shipment Pin"
                value={shipmentDetails?.generatedPin || "—"}
              />
            </div>
          </ExpandableHeader>

          <h3
            ref={setSectionRef("Comments")}
            className="text-fluid-lg font-semibold mb-fluid-2"
          >
            Comments
          </h3>

          <ExpandableHeader
  headerLabel="Comments"
  icon={FileText}
  headerType="info"
  initiallyExpanded={false}
>
  <div
    className="grid grid-cols-1 gap-6 bg-[#F9FAFE] p-fluid-3 text-fluid-base 
              text-gray-800 dark:bg-acs-dark-surface dark:text-acs-dark-text"
  >
    <div className="flex flex-col gap-fluid-2">
      <p className="text-dense-xs text-gray-500"></p>

      <textarea
        rows={6}
        value={comments}
        onChange={(e) => setComments(e.target.value)}
        placeholder="Write a comment..."
        className="w-full border border-gray-300 rounded-md p-fluid-2 text-fluid-base resize-none 
          focus:outline-none focus:ring-2 focus:ring-blue-500 dark:border-acs-dark-border dark:bg-acs-dark-surface dark:focus:ring-[#3B5CCC]"
      />

<div className="flex justify-end items-center">
  <button
    onClick={handleSaveComments}
    disabled={isSavingComments}
    className="px-4 py-1.5 bg-[#1e2a74] text-white text-sm rounded hover:bg-[#2d3d99] 
               disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
  >
    {isSavingComments ? "Saving..." : "Save Comments"}
  </button>
</div>
    </div>
  </div>
</ExpandableHeader>

          <ShipmentDocuments
            uploadedDocs={uploadedDocs}
            fileTypeMap={fileTypeMap}
            handleDownload={handleDownload}
            handleDelete={handleDelete}
            setShowDocUploadModal={setShowDocUploadModal}
            isCarrier={isCarrier}
            setSectionRef={setSectionRef}
          />

          <ShipmentActivity
            setSectionRef={setSectionRef}
            isActivityLoading={isActivityLoading}
            activityLogs={activityLogs}
            formatDisplayDate={formatDisplayDate}
            isOpen={showActivityPanel}
            onOpen={openActivityPanel}
            onClose={() => setShowActivityPanel(false)}
            showInline={false}
          />
        </div>
      </ScrollbarWrapper>
      {/* === RIGHT STATIC SUMMARY PANEL === */}

          <RenderShipmentModals
            showDocUploadModal={showDocUploadModal}
            setShowDocUploadModal={setShowDocUploadModal}
        showActualsModal={showActualsModal}
        setShowActualsModal={setShowActualsModal}
        showStopReasonModal={showStopReasonModal}
        setShowStopReasonModal={setShowStopReasonModal}
        showModal={showModal}
        setShowModal={setShowModal}
        shipmentDetails={shipmentDetails}
        shipmentNumber={shipmentNumber}
        fetchShipmentDetails={fetchShipmentDetails}
        showProModal={showProModal}
        setShowProModal={setShowProModal}
        updateShipmentStatus={updateShipmentStatus}
        handleUploadSuccess={handleUploadSuccess}
        onStopReasonAdded={handleStopReasonAdded}
        showRecallModal={showRecallModal}
        setShowRecallModal={setShowRecallModal}
        handleRecallConfirm={handleRecallConfirm}   //// Doesn't exit
        showReorderModal={showReorderModal}
        setShowReorderModal={setShowReorderModal}
        showAddStopModal={showAddStopModal}
        setShowAddStopModal={setShowAddStopModal}
        handleStopAdded={handleStopAdded}
        showReceiverCarrierModal={showReceiverCarrierModal}
        setShowReceiverCarrierModal={setShowReceiverCarrierModal}
        receiverCarriers={receiverCarriers}
        initialReceiverCarrier={initialReceiverCarrier}
            showCancelShipmentModal={showCancelShipmentModal}
            setShowCancelShipmentModal={setShowCancelShipmentModal}
        showRemoveOrdersModal={showRemoveOrdersModal}
        setShowRemoveOrdersModal={setShowRemoveOrdersModal}
        handleRemoveOrdersConfirm={handleRemoveOrdersConfirm}
        handleCancelConfirm={handleCancelAndExit}
        showRejectModal={showRejectModal}
        setShowRejectModal={setShowRejectModal}
        handleRejectConfirm={(reason) =>
          handleReject(
            shipmentNumber,
            fetchShipmentDetails,
            "Rejected",
            "reject-shipment",
            reason
          )
        }
        availableStops={showActualsModal.availableStops || []}
      />

      {showProModal && (
        <ProNumberModal
          onClose={() => setShowProModal(false)}
          onSave={proModalMode === "edit" ? handleUpdateProNumber : handleAcceptWithProNumber}
          initialProNumber={proModalMode === "edit" ? shipmentDetails?.proNumber || "" : ""}
          isEdit={proModalMode === "edit"}
        />
      )}

      {showReorderModal && shipmentDetails?.shipmentStops?.length > 0 && (
        <RenderShipmentModals
          showReorderModal={true}
          setShowReorderModal={setShowReorderModal}
          shipmentDetails={shipmentDetails}
          shipmentNumber={shipmentNumber}
          fetchShipmentDetails={fetchShipmentDetails}
        />
      )}
      {
  showRefreshMilesWarning && (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      <div className="bg-white rounded-lg shadow-xl p-6 w-[420px] max-w-[90vw]">
        <div className="flex items-center gap-3 mb-3">
          <div className="w-9 h-9 rounded-full bg-amber-100 flex items-center justify-center flex-shrink-0">
            <span className="text-amber-600 text-lg font-bold">!</span>
          </div>
          <h3 className="text-base font-semibold text-gray-800">
            Shipment Already Invoiced
          </h3>
        </div>
        <p className="text-sm text-gray-600 mb-3">
          This shipment has an invoice on record. Refreshing transit
          miles may affect billing calculations.
        </p>
        <div className="bg-amber-50 border-l-4 border-amber-400 px-3 py-2 rounded text-sm text-gray-700 mb-4">
          · Invoice:
          <strong>{shipmentDetails?.invoiceNumber}</strong>
          {shipmentDetails?.invoiceStatus && (
            <>
              {" "}
              · Status:
              <strong>{shipmentDetails.invoiceStatus}</strong>
            </>
          )}
          {shipmentDetails?.invoiceDate && (
            <>
              {" "}
              · Date:
              <strong>{formatDateOnly(shipmentDetails.invoiceDate)}</strong>
            </>
          )}
        </div>
        <p className="text-sm text-gray-600 mb-5">
          Do you still want to refresh the miles for shipment{" "}
          <strong>{shipmentNumber}</strong>?
        </p>
        <div className="flex justify-end gap-3">
          <button
            onClick={() => setShowRefreshMilesWarning(false)}
            className="px-4 py-1.5 text-sm border border-gray-300 rounded hover:bg-gray-50 transition"
          >
            Cancel
          </button>
          <button
            onClick={() => {
              setShowRefreshMilesWarning(false);
              handleRefreshMiles();
            }}
            className="px-4 py-1.5 text-sm bg-amber-600 text-white rounded hover:bg-amber-700 transition"
          >
            Yes, Refresh Miles
          </button>
        </div>
      </div>
    </div>
  )}
  {showRefreshRatesWarning && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
          <div className="bg-white rounded-lg shadow-xl p-6 w-[420px] max-w-[90vw]">
            <div className="flex items-center gap-3 mb-3">
              <div className="w-9 h-9 rounded-full bg-amber-100 flex items-center justify-center flex-shrink-0">
                <span className="text-amber-600 text-lg font-bold">!</span>
              </div>
              <h3 className="text-base font-semibold text-gray-800">
                Shipment Already Invoiced
              </h3>
            </div>
            <p className="text-sm text-gray-600 mb-3">
              This shipment has an invoice on record. Refreshing rates may
              affect billing calculations.
            </p>
            <div className="bg-amber-50 border-l-4 border-amber-400 px-3 py-2 rounded text-sm text-gray-700 mb-4">
              · Invoice:
              <strong>{shipmentDetails?.invoiceNumber}</strong>
              {shipmentDetails?.invoiceStatus && (
                <>
                  {" "}
                  · Status:
                  <strong>{shipmentDetails.invoiceStatus}</strong>
                </>
              )}
              {shipmentDetails?.invoiceDate && (
                <>
                  {" "}
                  · Date:
                  <strong>{formatDateOnly(shipmentDetails.invoiceDate)}</strong>
                </>
              )}
            </div>
            <p className="text-sm text-gray-600 mb-5">
              Do you still want to refresh the rates for shipment{" "}
              <strong>{shipmentNumber}</strong>?
            </p>
            <div className="flex justify-end gap-3">
              <button
                onClick={() => setShowRefreshRatesWarning(false)}
                className="px-4 py-1.5 text-sm border border-gray-300 rounded hover:bg-gray-50 transition"
              >
                Cancel
              </button>
              <button
                onClick={() => {
                  setShowRefreshRatesWarning(false);
                  handleRefreshRates();
                }}
                className="px-4 py-1.5 text-sm bg-amber-600 text-white rounded hover:bg-amber-700 transition"
              >
                Yes, Refresh Rates
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ShipmentDetailsView;
